import { gql } from '@apollo/client';
export var ActivateHemGatewayErrorType = /*#__PURE__*/ function(ActivateHemGatewayErrorType) {
    ActivateHemGatewayErrorType["Duplicate"] = "DUPLICATE";
    ActivateHemGatewayErrorType["InvalidHemGateway"] = "INVALID_HEM_GATEWAY";
    ActivateHemGatewayErrorType["None"] = "NONE";
    ActivateHemGatewayErrorType["NotFound"] = "NOT_FOUND";
    ActivateHemGatewayErrorType["UnhandledError"] = "UNHANDLED_ERROR";
    return ActivateHemGatewayErrorType;
}({});
export var AddMeterReadingPayloadError = /*#__PURE__*/ function(AddMeterReadingPayloadError) {
    AddMeterReadingPayloadError["Contractnotfound"] = "CONTRACTNOTFOUND";
    AddMeterReadingPayloadError["Fielderrors"] = "FIELDERRORS";
    AddMeterReadingPayloadError["Futurereadingwithsmallervalue"] = "FUTUREREADINGWITHSMALLERVALUE";
    AddMeterReadingPayloadError["Incorrectvalue"] = "INCORRECTVALUE";
    AddMeterReadingPayloadError["Invaliddate"] = "INVALIDDATE";
    AddMeterReadingPayloadError["Invalidprofilesum"] = "INVALIDPROFILESUM";
    AddMeterReadingPayloadError["Noreadings"] = "NOREADINGS";
    AddMeterReadingPayloadError["Obiscodemissing"] = "OBISCODEMISSING";
    AddMeterReadingPayloadError["Obiscodesnotvalid"] = "OBISCODESNOTVALID";
    AddMeterReadingPayloadError["Obiscodeunknown"] = "OBISCODEUNKNOWN";
    AddMeterReadingPayloadError["Previousreadingwithhighervalue"] = "PREVIOUSREADINGWITHHIGHERVALUE";
    AddMeterReadingPayloadError["Readingdatealreadyexists"] = "READINGDATEALREADYEXISTS";
    AddMeterReadingPayloadError["Readingdateinbilledperiod"] = "READINGDATEINBILLEDPERIOD";
    AddMeterReadingPayloadError["Readingdateinfuture"] = "READINGDATEINFUTURE";
    AddMeterReadingPayloadError["Readingdateoutsidecontract"] = "READINGDATEOUTSIDECONTRACT";
    AddMeterReadingPayloadError["Readingusagesumisnotplausible"] = "READINGUSAGESUMISNOTPLAUSIBLE";
    AddMeterReadingPayloadError["Requestisnotallowed"] = "REQUESTISNOTALLOWED";
    AddMeterReadingPayloadError["Toomanydigits"] = "TOOMANYDIGITS";
    AddMeterReadingPayloadError["Undefined"] = "UNDEFINED";
    return AddMeterReadingPayloadError;
}({});
export var AddReadingPayloadError = /*#__PURE__*/ function(AddReadingPayloadError) {
    /** Contract Id not found on authorized customer */ AddReadingPayloadError["ContractNotFound"] = "CONTRACT_NOT_FOUND";
    /** Fehlerhafte Zählerstände. Fehlerdetails in FieldErrors. */ AddReadingPayloadError["Fielderrors"] = "FIELDERRORS";
    /** Es existiert bereits ein niedrigerer Zählerstand in der Zukunft */ AddReadingPayloadError["FutureReadingWithSmallerValue"] = "FUTURE_READING_WITH_SMALLER_VALUE";
    /** Die Eingabe ist nicht korrekt */ AddReadingPayloadError["Incorrectvalue"] = "INCORRECTVALUE";
    /** Ablesedatum liegt entweder außerhalb der Vertragsbelieferung oder Datum ist ungültig. Datum muss im Format YYYY-MM-DD sein. */ AddReadingPayloadError["Invaliddate"] = "INVALIDDATE";
    /** Unplausible Daten */ AddReadingPayloadError["InvalidProfileSum"] = "INVALID_PROFILE_SUM";
    /** No readings were committed or OBIS codes were empty */ AddReadingPayloadError["NoReadings"] = "NO_READINGS";
    /** Obis-Codes der Zählwerke sind nicht korrekt */ AddReadingPayloadError["ObiscodesNotValid"] = "OBISCODES_NOT_VALID";
    /** OBIS Code was not submitted but is present on the contract's counter */ AddReadingPayloadError["ObisCodeMissing"] = "OBIS_CODE_MISSING";
    /** OBIS Code was submitted but is unknown for this contract */ AddReadingPayloadError["ObisCodeUnknown"] = "OBIS_CODE_UNKNOWN";
    /** Es existiert bereits ein höherer in der Vergangenheit */ AddReadingPayloadError["PreviousReadingWithHigherValue"] = "PREVIOUS_READING_WITH_HIGHER_VALUE";
    /** A reading for this reading date already exists */ AddReadingPayloadError["ReadingDateAlreadyExists"] = "READING_DATE_ALREADY_EXISTS";
    /** The reading date is already covered by an invoice */ AddReadingPayloadError["ReadingDateInBilledPeriod"] = "READING_DATE_IN_BILLED_PERIOD";
    /** No readings for the future may be committed */ AddReadingPayloadError["ReadingDateInFuture"] = "READING_DATE_IN_FUTURE";
    /** The reading date is outside of StartDate-EndDate */ AddReadingPayloadError["ReadingDateOutsideContract"] = "READING_DATE_OUTSIDE_CONTRACT";
    /** Der Verbrauch ist nicht plausibel */ AddReadingPayloadError["ReadingUsageSumIsNotPlausible"] = "READING_USAGE_SUM_IS_NOT_PLAUSIBLE";
    /** Vorgang ist nicht erlaubt */ AddReadingPayloadError["RequestIsNotAllowed"] = "REQUEST_IS_NOT_ALLOWED";
    /** This register has less significant digits than were submitted */ AddReadingPayloadError["TooManyDigits"] = "TOO_MANY_DIGITS";
    /** Unbekannter Fehler */ AddReadingPayloadError["Undefined"] = "UNDEFINED";
    /** Count of OBIS Codes not matching PowerCloud */ AddReadingPayloadError["WrongObisCodeCount"] = "WRONG_OBIS_CODE_COUNT";
    return AddReadingPayloadError;
}({});
export var AppContractContentCard = /*#__PURE__*/ function(AppContractContentCard) {
    AppContractContentCard["BillingAddress"] = "BILLING_ADDRESS";
    AppContractContentCard["ChargeHistory"] = "CHARGE_HISTORY";
    AppContractContentCard["CommodityStatus"] = "COMMODITY_STATUS";
    AppContractContentCard["ContractDetails"] = "CONTRACT_DETAILS";
    AppContractContentCard["CostBalance"] = "COST_BALANCE";
    AppContractContentCard["DeliveryAddress"] = "DELIVERY_ADDRESS";
    AppContractContentCard["Deposit"] = "DEPOSIT";
    AppContractContentCard["DynamicFallback"] = "DYNAMIC_FALLBACK";
    AppContractContentCard["EmobilityStatus"] = "EMOBILITY_STATUS";
    /** @deprecated Deprecated value. Use StromWalletSmartMeter or MeterReadingDefault instead. */ AppContractContentCard["MeterReading"] = "METER_READING";
    AppContractContentCard["MeterReadingDefault"] = "METER_READING_DEFAULT";
    AppContractContentCard["PaymentInfo"] = "PAYMENT_INFO";
    AppContractContentCard["ProductHeader"] = "PRODUCT_HEADER";
    /** @deprecated Deprecated value. Use EmobilityStatus or CommodityStatus instead. */ AppContractContentCard["Status"] = "STATUS";
    AppContractContentCard["StromWalletSmartMeter"] = "STROM_WALLET_SMART_METER";
    AppContractContentCard["TaskSummary"] = "TASK_SUMMARY";
    AppContractContentCard["Teaser"] = "TEASER";
    AppContractContentCard["WorkingPrice"] = "WORKING_PRICE";
    return AppContractContentCard;
}({});
export var AppProductCategory = /*#__PURE__*/ function(AppProductCategory) {
    AppProductCategory["Fahrstrom"] = "FAHRSTROM";
    AppProductCategory["Gas"] = "GAS";
    AppProductCategory["Heatpump"] = "HEATPUMP";
    AppProductCategory["Power"] = "POWER";
    AppProductCategory["Storageheater"] = "STORAGEHEATER";
    AppProductCategory["Stromwallet"] = "STROMWALLET";
    AppProductCategory["Unknown"] = "UNKNOWN";
    return AppProductCategory;
}({});
/** Defines when a policy shall be executed. */ export var ApplyPolicy = /*#__PURE__*/ function(ApplyPolicy) {
    /** After the resolver was executed. */ ApplyPolicy["AfterResolver"] = "AFTER_RESOLVER";
    /** Before the resolver was executed. */ ApplyPolicy["BeforeResolver"] = "BEFORE_RESOLVER";
    /** The policy is applied in the validation step before the execution. */ ApplyPolicy["Validation"] = "VALIDATION";
    return ApplyPolicy;
}({});
export var B2bRsBillingEndMonth = /*#__PURE__*/ function(B2bRsBillingEndMonth) {
    B2bRsBillingEndMonth["April"] = "APRIL";
    B2bRsBillingEndMonth["August"] = "AUGUST";
    B2bRsBillingEndMonth["December"] = "DECEMBER";
    B2bRsBillingEndMonth["February"] = "FEBRUARY";
    B2bRsBillingEndMonth["January"] = "JANUARY";
    B2bRsBillingEndMonth["July"] = "JULY";
    B2bRsBillingEndMonth["June"] = "JUNE";
    B2bRsBillingEndMonth["March"] = "MARCH";
    B2bRsBillingEndMonth["May"] = "MAY";
    B2bRsBillingEndMonth["November"] = "NOVEMBER";
    B2bRsBillingEndMonth["October"] = "OCTOBER";
    B2bRsBillingEndMonth["September"] = "SEPTEMBER";
    return B2bRsBillingEndMonth;
}({});
export var B2bRsBillingInterval = /*#__PURE__*/ function(B2bRsBillingInterval) {
    B2bRsBillingInterval["Annually"] = "ANNUALLY";
    B2bRsBillingInterval["BiMonthly"] = "BI_MONTHLY";
    B2bRsBillingInterval["Monthly"] = "MONTHLY";
    B2bRsBillingInterval["Quarterly"] = "QUARTERLY";
    B2bRsBillingInterval["SemiAnnually"] = "SEMI_ANNUALLY";
    B2bRsBillingInterval["TetraMonthly"] = "TETRA_MONTHLY";
    return B2bRsBillingInterval;
}({});
export var B2bRsBillingType = /*#__PURE__*/ function(B2bRsBillingType) {
    B2bRsBillingType["BillingInvoice"] = "BILLING_INVOICE";
    B2bRsBillingType["BillingPlan"] = "BILLING_PLAN";
    B2bRsBillingType["LiveBilling"] = "LIVE_BILLING";
    return B2bRsBillingType;
}({});
export var B2bRsCalculateDeliveryLocationPriceErrorType = /*#__PURE__*/ function(B2bRsCalculateDeliveryLocationPriceErrorType) {
    B2bRsCalculateDeliveryLocationPriceErrorType["InternalError"] = "INTERNAL_ERROR";
    B2bRsCalculateDeliveryLocationPriceErrorType["InvalidRequestForElectricityCommodity"] = "INVALID_REQUEST_FOR_ELECTRICITY_COMMODITY";
    return B2bRsCalculateDeliveryLocationPriceErrorType;
}({});
export var B2bRsCalculateWorkPriceErrorType = /*#__PURE__*/ function(B2bRsCalculateWorkPriceErrorType) {
    B2bRsCalculateWorkPriceErrorType["InternalError"] = "INTERNAL_ERROR";
    return B2bRsCalculateWorkPriceErrorType;
}({});
export var B2bRsCommodity = /*#__PURE__*/ function(B2bRsCommodity) {
    B2bRsCommodity["Electricity"] = "ELECTRICITY";
    B2bRsCommodity["Gas"] = "GAS";
    return B2bRsCommodity;
}({});
export var B2bRsConcessionType = /*#__PURE__*/ function(B2bRsConcessionType) {
    B2bRsConcessionType["Gas"] = "GAS";
    B2bRsConcessionType["Inkl"] = "INKL";
    B2bRsConcessionType["Svk"] = "SVK";
    B2bRsConcessionType["SvkNt"] = "SVK_NT";
    B2bRsConcessionType["Tk1"] = "TK1";
    B2bRsConcessionType["Tk2"] = "TK2";
    B2bRsConcessionType["Tk3"] = "TK3";
    B2bRsConcessionType["Tk4"] = "TK4";
    B2bRsConcessionType["TkNt"] = "TK_NT";
    return B2bRsConcessionType;
}({});
export var B2bRsCreateMeterErrorType = /*#__PURE__*/ function(B2bRsCreateMeterErrorType) {
    B2bRsCreateMeterErrorType["DeliveryProcessInformationIncoherent"] = "DELIVERY_PROCESS_INFORMATION_INCOHERENT";
    B2bRsCreateMeterErrorType["InsufficientConsumptionHt"] = "INSUFFICIENT_CONSUMPTION_HT";
    B2bRsCreateMeterErrorType["MissingAddressInformation"] = "MISSING_ADDRESS_INFORMATION";
    B2bRsCreateMeterErrorType["NoCommoditySpecified"] = "NO_COMMODITY_SPECIFIED";
    B2bRsCreateMeterErrorType["OpportunityNotFound"] = "OPPORTUNITY_NOT_FOUND";
    B2bRsCreateMeterErrorType["PreviousSupplierInformationMissing"] = "PREVIOUS_SUPPLIER_INFORMATION_MISSING";
    B2bRsCreateMeterErrorType["StartDateTooFarInTheFuture"] = "START_DATE_TOO_FAR_IN_THE_FUTURE";
    return B2bRsCreateMeterErrorType;
}({});
export var B2bRsCreateOfferErrorType = /*#__PURE__*/ function(B2bRsCreateOfferErrorType) {
    B2bRsCreateOfferErrorType["EmptyMeterListProvided"] = "EMPTY_METER_LIST_PROVIDED";
    B2bRsCreateOfferErrorType["MeterStillPendingToSync"] = "METER_STILL_PENDING_TO_SYNC";
    B2bRsCreateOfferErrorType["OfferIsAlreadySignedInOfferPackage"] = "OFFER_IS_ALREADY_SIGNED_IN_OFFER_PACKAGE";
    B2bRsCreateOfferErrorType["OfferPackageNotFound"] = "OFFER_PACKAGE_NOT_FOUND";
    B2bRsCreateOfferErrorType["OpportunityNotFound"] = "OPPORTUNITY_NOT_FOUND";
    B2bRsCreateOfferErrorType["OpportunityWithoutMeters"] = "OPPORTUNITY_WITHOUT_METERS";
    return B2bRsCreateOfferErrorType;
}({});
export var B2bRsCreateOpportunityErrorType = /*#__PURE__*/ function(B2bRsCreateOpportunityErrorType) {
    B2bRsCreateOpportunityErrorType["MissingAddressInformation"] = "MISSING_ADDRESS_INFORMATION";
    B2bRsCreateOpportunityErrorType["MissingCompanyName"] = "MISSING_COMPANY_NAME";
    B2bRsCreateOpportunityErrorType["MissingContactInformation"] = "MISSING_CONTACT_INFORMATION";
    return B2bRsCreateOpportunityErrorType;
}({});
export var B2bRsDeliveryProcess = /*#__PURE__*/ function(B2bRsDeliveryProcess) {
    B2bRsDeliveryProcess["NewMoveIn"] = "NEW_MOVE_IN";
    B2bRsDeliveryProcess["SupplierChange"] = "SUPPLIER_CHANGE";
    return B2bRsDeliveryProcess;
}({});
export var B2bRsElectricityMeterType = /*#__PURE__*/ function(B2bRsElectricityMeterType) {
    B2bRsElectricityMeterType["DoubleTariff"] = "DOUBLE_TARIFF";
    B2bRsElectricityMeterType["SingleTariff"] = "SINGLE_TARIFF";
    return B2bRsElectricityMeterType;
}({});
export var B2bRsElectricityQuality = /*#__PURE__*/ function(B2bRsElectricityQuality) {
    B2bRsElectricityQuality["GermanMix"] = "GERMAN_MIX";
    B2bRsElectricityQuality["GermanSolar"] = "GERMAN_SOLAR";
    B2bRsElectricityQuality["GermanWater"] = "GERMAN_WATER";
    B2bRsElectricityQuality["GermanWind"] = "GERMAN_WIND";
    B2bRsElectricityQuality["TuvNorth"] = "TUV_NORTH";
    return B2bRsElectricityQuality;
}({});
export var B2bRsGasCounterType = /*#__PURE__*/ function(B2bRsGasCounterType) {
    B2bRsGasCounterType["Diaphragm"] = "DIAPHRAGM";
    B2bRsGasCounterType["RotaryDisplacement"] = "ROTARY_DISPLACEMENT";
    B2bRsGasCounterType["Turbine"] = "TURBINE";
    return B2bRsGasCounterType;
}({});
export var B2bRsGasPressureLevel = /*#__PURE__*/ function(B2bRsGasPressureLevel) {
    B2bRsGasPressureLevel["High"] = "HIGH";
    B2bRsGasPressureLevel["Low"] = "LOW";
    B2bRsGasPressureLevel["Medium"] = "MEDIUM";
    return B2bRsGasPressureLevel;
}({});
export var B2bRsGasProfile = /*#__PURE__*/ function(B2bRsGasProfile) {
    B2bRsGasProfile["G2Point5"] = "G2_POINT5";
    B2bRsGasProfile["G4"] = "G4";
    B2bRsGasProfile["G6"] = "G6";
    B2bRsGasProfile["G10"] = "G10";
    B2bRsGasProfile["G16"] = "G16";
    B2bRsGasProfile["G25"] = "G25";
    B2bRsGasProfile["G40"] = "G40";
    B2bRsGasProfile["G65"] = "G65";
    B2bRsGasProfile["G100"] = "G100";
    B2bRsGasProfile["G160"] = "G160";
    B2bRsGasProfile["G250"] = "G250";
    B2bRsGasProfile["G400"] = "G400";
    B2bRsGasProfile["G650"] = "G650";
    B2bRsGasProfile["G1000"] = "G1000";
    B2bRsGasProfile["G1600"] = "G1600";
    B2bRsGasProfile["G2500"] = "G2500";
    B2bRsGasProfile["G4000"] = "G4000";
    B2bRsGasProfile["G6500"] = "G6500";
    return B2bRsGasProfile;
}({});
export var B2bRsGetBankInformationErrorType = /*#__PURE__*/ function(B2bRsGetBankInformationErrorType) {
    B2bRsGetBankInformationErrorType["InvalidIban"] = "INVALID_IBAN";
    B2bRsGetBankInformationErrorType["NoBankInformation"] = "NO_BANK_INFORMATION";
    return B2bRsGetBankInformationErrorType;
}({});
export var B2bRsGetBusinessTariffGridsErrorType = /*#__PURE__*/ function(B2bRsGetBusinessTariffGridsErrorType) {
    B2bRsGetBusinessTariffGridsErrorType["InvalidAddress"] = "INVALID_ADDRESS";
    return B2bRsGetBusinessTariffGridsErrorType;
}({});
export var B2bRsIssueOfferErrorType = /*#__PURE__*/ function(B2bRsIssueOfferErrorType) {
    B2bRsIssueOfferErrorType["BindingPeriodAlreadyExpired"] = "BINDING_PERIOD_ALREADY_EXPIRED";
    B2bRsIssueOfferErrorType["OfferMustBeCalculated"] = "OFFER_MUST_BE_CALCULATED";
    B2bRsIssueOfferErrorType["OfferNotFound"] = "OFFER_NOT_FOUND";
    B2bRsIssueOfferErrorType["OfferVariantNotFound"] = "OFFER_VARIANT_NOT_FOUND";
    B2bRsIssueOfferErrorType["OpportunityNotFound"] = "OPPORTUNITY_NOT_FOUND";
    return B2bRsIssueOfferErrorType;
}({});
export var B2bRsOfferStatus = /*#__PURE__*/ function(B2bRsOfferStatus) {
    B2bRsOfferStatus["AlternativeChosen"] = "ALTERNATIVE_CHOSEN";
    B2bRsOfferStatus["Calculated"] = "CALCULATED";
    B2bRsOfferStatus["Expired"] = "EXPIRED";
    B2bRsOfferStatus["InCalculation"] = "IN_CALCULATION";
    B2bRsOfferStatus["InIssuing"] = "IN_ISSUING";
    B2bRsOfferStatus["InWithdrawal"] = "IN_WITHDRAWAL";
    B2bRsOfferStatus["Issued"] = "ISSUED";
    B2bRsOfferStatus["Open"] = "OPEN";
    B2bRsOfferStatus["Rejected"] = "REJECTED";
    B2bRsOfferStatus["Signed"] = "SIGNED";
    B2bRsOfferStatus["Withdrawn"] = "WITHDRAWN";
    return B2bRsOfferStatus;
}({});
export var B2bRsOfferVariantStatus = /*#__PURE__*/ function(B2bRsOfferVariantStatus) {
    B2bRsOfferVariantStatus["Discarded"] = "DISCARDED";
    B2bRsOfferVariantStatus["Issued"] = "ISSUED";
    B2bRsOfferVariantStatus["Lost"] = "LOST";
    B2bRsOfferVariantStatus["Open"] = "OPEN";
    B2bRsOfferVariantStatus["Selected"] = "SELECTED";
    B2bRsOfferVariantStatus["Withdrawn"] = "WITHDRAWN";
    B2bRsOfferVariantStatus["Won"] = "WON";
    return B2bRsOfferVariantStatus;
}({});
export var B2bRsOpportunityStatus = /*#__PURE__*/ function(B2bRsOpportunityStatus) {
    B2bRsOpportunityStatus["Finished"] = "FINISHED";
    B2bRsOpportunityStatus["InProgress"] = "IN_PROGRESS";
    B2bRsOpportunityStatus["Open"] = "OPEN";
    return B2bRsOpportunityStatus;
}({});
export var B2bRsProcessStatus = /*#__PURE__*/ function(B2bRsProcessStatus) {
    B2bRsProcessStatus["Completed"] = "COMPLETED";
    B2bRsProcessStatus["Failed"] = "FAILED";
    B2bRsProcessStatus["Running"] = "RUNNING";
    return B2bRsProcessStatus;
}({});
export var B2bRsProcessType = /*#__PURE__*/ function(B2bRsProcessType) {
    B2bRsProcessType["UpsertAndCalculateOffer"] = "UPSERT_AND_CALCULATE_OFFER";
    B2bRsProcessType["UpsertMeter"] = "UPSERT_METER";
    return B2bRsProcessType;
}({});
export var B2bRsProduct = /*#__PURE__*/ function(B2bRsProduct) {
    B2bRsProduct["ElectricityBackToBack"] = "ELECTRICITY_BACK_TO_BACK";
    B2bRsProduct["ElectricityBackToBackDoubleTariff"] = "ELECTRICITY_BACK_TO_BACK_DOUBLE_TARIFF";
    B2bRsProduct["ElectricitySpot"] = "ELECTRICITY_SPOT";
    return B2bRsProduct;
}({});
export var B2bRsTariffMetering = /*#__PURE__*/ function(B2bRsTariffMetering) {
    B2bRsTariffMetering["SingleTariff"] = "SINGLE_TARIFF";
    B2bRsTariffMetering["TwoTariff"] = "TWO_TARIFF";
    return B2bRsTariffMetering;
}({});
export var B2bRsUpdateOfferErrorType = /*#__PURE__*/ function(B2bRsUpdateOfferErrorType) {
    B2bRsUpdateOfferErrorType["InvalidOfferStatusTransition"] = "INVALID_OFFER_STATUS_TRANSITION";
    B2bRsUpdateOfferErrorType["OfferAlreadyInCalculation"] = "OFFER_ALREADY_IN_CALCULATION";
    B2bRsUpdateOfferErrorType["OfferNotFound"] = "OFFER_NOT_FOUND";
    B2bRsUpdateOfferErrorType["OpportunityNotFound"] = "OPPORTUNITY_NOT_FOUND";
    return B2bRsUpdateOfferErrorType;
}({});
export var B2bRsWithdrawnOfferErrorType = /*#__PURE__*/ function(B2bRsWithdrawnOfferErrorType) {
    B2bRsWithdrawnOfferErrorType["MissingAgreementIdOnOffer"] = "MISSING_AGREEMENT_ID_ON_OFFER";
    B2bRsWithdrawnOfferErrorType["OfferIsNotIssued"] = "OFFER_IS_NOT_ISSUED";
    B2bRsWithdrawnOfferErrorType["OfferNotFound"] = "OFFER_NOT_FOUND";
    B2bRsWithdrawnOfferErrorType["OpportunityNotFound"] = "OPPORTUNITY_NOT_FOUND";
    return B2bRsWithdrawnOfferErrorType;
}({});
export var B2bSpBillingEndMonth = /*#__PURE__*/ function(B2bSpBillingEndMonth) {
    B2bSpBillingEndMonth["April"] = "APRIL";
    B2bSpBillingEndMonth["August"] = "AUGUST";
    B2bSpBillingEndMonth["December"] = "DECEMBER";
    B2bSpBillingEndMonth["February"] = "FEBRUARY";
    B2bSpBillingEndMonth["January"] = "JANUARY";
    B2bSpBillingEndMonth["July"] = "JULY";
    B2bSpBillingEndMonth["June"] = "JUNE";
    B2bSpBillingEndMonth["March"] = "MARCH";
    B2bSpBillingEndMonth["May"] = "MAY";
    B2bSpBillingEndMonth["November"] = "NOVEMBER";
    B2bSpBillingEndMonth["October"] = "OCTOBER";
    B2bSpBillingEndMonth["September"] = "SEPTEMBER";
    return B2bSpBillingEndMonth;
}({});
export var B2bSpBillingInterval = /*#__PURE__*/ function(B2bSpBillingInterval) {
    B2bSpBillingInterval["Annually"] = "ANNUALLY";
    B2bSpBillingInterval["BiMonthly"] = "BI_MONTHLY";
    B2bSpBillingInterval["Monthly"] = "MONTHLY";
    B2bSpBillingInterval["Quarterly"] = "QUARTERLY";
    B2bSpBillingInterval["SemiAnnually"] = "SEMI_ANNUALLY";
    B2bSpBillingInterval["TetraMonthly"] = "TETRA_MONTHLY";
    return B2bSpBillingInterval;
}({});
export var B2bSpBillingType = /*#__PURE__*/ function(B2bSpBillingType) {
    B2bSpBillingType["BillingInvoice"] = "BILLING_INVOICE";
    B2bSpBillingType["BillingPlan"] = "BILLING_PLAN";
    B2bSpBillingType["LiveBilling"] = "LIVE_BILLING";
    return B2bSpBillingType;
}({});
export var B2bSpCommodity = /*#__PURE__*/ function(B2bSpCommodity) {
    B2bSpCommodity["Electricity"] = "ELECTRICITY";
    B2bSpCommodity["Gas"] = "GAS";
    return B2bSpCommodity;
}({});
export var B2bSpDeliveryProcess = /*#__PURE__*/ function(B2bSpDeliveryProcess) {
    B2bSpDeliveryProcess["NewMoveIn"] = "NEW_MOVE_IN";
    B2bSpDeliveryProcess["SupplierChange"] = "SUPPLIER_CHANGE";
    return B2bSpDeliveryProcess;
}({});
export var B2bSpElectricityAccountingProcedure = /*#__PURE__*/ function(B2bSpElectricityAccountingProcedure) {
    B2bSpElectricityAccountingProcedure["Rlm"] = "RLM";
    B2bSpElectricityAccountingProcedure["Slp"] = "SLP";
    return B2bSpElectricityAccountingProcedure;
}({});
export var B2bSpElectricityMeterType = /*#__PURE__*/ function(B2bSpElectricityMeterType) {
    B2bSpElectricityMeterType["DoubleTariff"] = "DOUBLE_TARIFF";
    B2bSpElectricityMeterType["LoadProfile"] = "LOAD_PROFILE";
    B2bSpElectricityMeterType["SingleTariff"] = "SINGLE_TARIFF";
    return B2bSpElectricityMeterType;
}({});
export var B2bSpElectricityQuality = /*#__PURE__*/ function(B2bSpElectricityQuality) {
    B2bSpElectricityQuality["GermanMix"] = "GERMAN_MIX";
    B2bSpElectricityQuality["GermanSolar"] = "GERMAN_SOLAR";
    B2bSpElectricityQuality["GermanWater"] = "GERMAN_WATER";
    B2bSpElectricityQuality["GermanWind"] = "GERMAN_WIND";
    B2bSpElectricityQuality["TuvNorth"] = "TUV_NORTH";
    return B2bSpElectricityQuality;
}({});
export var B2bSpEventEntityType = /*#__PURE__*/ function(B2bSpEventEntityType) {
    B2bSpEventEntityType["Customer"] = "CUSTOMER";
    B2bSpEventEntityType["Meter"] = "METER";
    B2bSpEventEntityType["Offer"] = "OFFER";
    B2bSpEventEntityType["Opportunity"] = "OPPORTUNITY";
    return B2bSpEventEntityType;
}({});
export var B2bSpGasMeterSize = /*#__PURE__*/ function(B2bSpGasMeterSize) {
    B2bSpGasMeterSize["G2_5"] = "G2_5";
    B2bSpGasMeterSize["G4"] = "G4";
    B2bSpGasMeterSize["G6"] = "G6";
    B2bSpGasMeterSize["G10"] = "G10";
    B2bSpGasMeterSize["G16"] = "G16";
    B2bSpGasMeterSize["G25"] = "G25";
    B2bSpGasMeterSize["G40"] = "G40";
    B2bSpGasMeterSize["G65"] = "G65";
    B2bSpGasMeterSize["G100"] = "G100";
    B2bSpGasMeterSize["G160"] = "G160";
    B2bSpGasMeterSize["G250"] = "G250";
    B2bSpGasMeterSize["G400"] = "G400";
    B2bSpGasMeterSize["G650"] = "G650";
    B2bSpGasMeterSize["G1000"] = "G1000";
    B2bSpGasMeterSize["G1600"] = "G1600";
    B2bSpGasMeterSize["G2500"] = "G2500";
    B2bSpGasMeterSize["G4000"] = "G4000";
    B2bSpGasMeterSize["G6500"] = "G6500";
    return B2bSpGasMeterSize;
}({});
export var B2bSpGasMeterType = /*#__PURE__*/ function(B2bSpGasMeterType) {
    B2bSpGasMeterType["Bellows"] = "BELLOWS";
    B2bSpGasMeterType["RotaryPistons"] = "ROTARY_PISTONS";
    B2bSpGasMeterType["Turbins"] = "TURBINS";
    return B2bSpGasMeterType;
}({});
export var B2bSpGasPressureLevel = /*#__PURE__*/ function(B2bSpGasPressureLevel) {
    B2bSpGasPressureLevel["High"] = "HIGH";
    B2bSpGasPressureLevel["Low"] = "LOW";
    B2bSpGasPressureLevel["Medium"] = "MEDIUM";
    return B2bSpGasPressureLevel;
}({});
export var B2bSpGasQuality = /*#__PURE__*/ function(B2bSpGasQuality) {
    B2bSpGasQuality["TuvNorth"] = "TUV_NORTH";
    return B2bSpGasQuality;
}({});
export var B2bSpLeadStatus = /*#__PURE__*/ function(B2bSpLeadStatus) {
    B2bSpLeadStatus["Accepted"] = "ACCEPTED";
    B2bSpLeadStatus["Pending"] = "PENDING";
    B2bSpLeadStatus["Rejected"] = "REJECTED";
    return B2bSpLeadStatus;
}({});
export var B2bSpMeteringProcedure = /*#__PURE__*/ function(B2bSpMeteringProcedure) {
    B2bSpMeteringProcedure["Rlm"] = "RLM";
    B2bSpMeteringProcedure["Slp"] = "SLP";
    return B2bSpMeteringProcedure;
}({});
export var B2bSpOfferStatus = /*#__PURE__*/ function(B2bSpOfferStatus) {
    B2bSpOfferStatus["AlternativeChosen"] = "ALTERNATIVE_CHOSEN";
    B2bSpOfferStatus["Calculated"] = "CALCULATED";
    B2bSpOfferStatus["Expired"] = "EXPIRED";
    B2bSpOfferStatus["InCalculation"] = "IN_CALCULATION";
    B2bSpOfferStatus["InClosing"] = "IN_CLOSING";
    B2bSpOfferStatus["InIssuing"] = "IN_ISSUING";
    B2bSpOfferStatus["Issued"] = "ISSUED";
    B2bSpOfferStatus["Open"] = "OPEN";
    B2bSpOfferStatus["Rejected"] = "REJECTED";
    B2bSpOfferStatus["Sent"] = "SENT";
    B2bSpOfferStatus["Signed"] = "SIGNED";
    B2bSpOfferStatus["Withdrawn"] = "WITHDRAWN";
    return B2bSpOfferStatus;
}({});
export var B2bSpOfferVariantStatus = /*#__PURE__*/ function(B2bSpOfferVariantStatus) {
    B2bSpOfferVariantStatus["Discarded"] = "DISCARDED";
    B2bSpOfferVariantStatus["Issued"] = "ISSUED";
    B2bSpOfferVariantStatus["Lost"] = "LOST";
    B2bSpOfferVariantStatus["Open"] = "OPEN";
    B2bSpOfferVariantStatus["Selected"] = "SELECTED";
    B2bSpOfferVariantStatus["Sent"] = "SENT";
    B2bSpOfferVariantStatus["Won"] = "WON";
    return B2bSpOfferVariantStatus;
}({});
export var B2bSpOpportunityStatus = /*#__PURE__*/ function(B2bSpOpportunityStatus) {
    B2bSpOpportunityStatus["Finished"] = "FINISHED";
    B2bSpOpportunityStatus["InProgress"] = "IN_PROGRESS";
    B2bSpOpportunityStatus["Open"] = "OPEN";
    return B2bSpOpportunityStatus;
}({});
export var B2bSpOrderStatus = /*#__PURE__*/ function(B2bSpOrderStatus) {
    B2bSpOrderStatus["Pending"] = "PENDING";
    B2bSpOrderStatus["Transferred"] = "TRANSFERRED";
    return B2bSpOrderStatus;
}({});
export var B2bSpProcessStatus = /*#__PURE__*/ function(B2bSpProcessStatus) {
    B2bSpProcessStatus["Completed"] = "COMPLETED";
    B2bSpProcessStatus["Failed"] = "FAILED";
    B2bSpProcessStatus["Running"] = "RUNNING";
    return B2bSpProcessStatus;
}({});
export var B2bSpProcessType = /*#__PURE__*/ function(B2bSpProcessType) {
    B2bSpProcessType["IssueOffer"] = "ISSUE_OFFER";
    B2bSpProcessType["OfferAgreementStateChanged"] = "OFFER_AGREEMENT_STATE_CHANGED";
    B2bSpProcessType["SentOffer"] = "SENT_OFFER";
    B2bSpProcessType["UpsertAndCalculateOffer"] = "UPSERT_AND_CALCULATE_OFFER";
    B2bSpProcessType["UpsertCustomer"] = "UPSERT_CUSTOMER";
    B2bSpProcessType["UpsertMeter"] = "UPSERT_METER";
    B2bSpProcessType["WithdrawOffer"] = "WITHDRAW_OFFER";
    return B2bSpProcessType;
}({});
export var B2bSpProduct = /*#__PURE__*/ function(B2bSpProduct) {
    B2bSpProduct["ElectricityBackToBack"] = "ELECTRICITY_BACK_TO_BACK";
    B2bSpProduct["ElectricitySpot"] = "ELECTRICITY_SPOT";
    B2bSpProduct["GasContingent"] = "GAS_CONTINGENT";
    return B2bSpProduct;
}({});
export var B2bSpTransferType = /*#__PURE__*/ function(B2bSpTransferType) {
    B2bSpTransferType["Gm"] = "GM";
    B2bSpTransferType["Manual"] = "MANUAL";
    B2bSpTransferType["Sdk"] = "SDK";
    return B2bSpTransferType;
}({});
export var B2bcsCreateLeadFormErrorType = /*#__PURE__*/ function(B2bcsCreateLeadFormErrorType) {
    B2bcsCreateLeadFormErrorType["InvalidAddress"] = "INVALID_ADDRESS";
    B2bcsCreateLeadFormErrorType["InvalidCompany"] = "INVALID_COMPANY";
    B2bcsCreateLeadFormErrorType["InvalidContact"] = "INVALID_CONTACT";
    B2bcsCreateLeadFormErrorType["InvalidEnergyData"] = "INVALID_ENERGY_DATA";
    B2bcsCreateLeadFormErrorType["InvalidGasData"] = "INVALID_GAS_DATA";
    return B2bcsCreateLeadFormErrorType;
}({});
export var B2bcsSubmitLeadFormErrorType = /*#__PURE__*/ function(B2bcsSubmitLeadFormErrorType) {
    B2bcsSubmitLeadFormErrorType["InvalidAddress"] = "INVALID_ADDRESS";
    B2bcsSubmitLeadFormErrorType["InvalidCompany"] = "INVALID_COMPANY";
    B2bcsSubmitLeadFormErrorType["InvalidContact"] = "INVALID_CONTACT";
    return B2bcsSubmitLeadFormErrorType;
}({});
export var B2cCampaignOfferType = /*#__PURE__*/ function(B2cCampaignOfferType) {
    B2cCampaignOfferType["ContractExtensionOffer"] = "CONTRACT_EXTENSION_OFFER";
    B2cCampaignOfferType["CrossSell"] = "CROSS_SELL";
    B2cCampaignOfferType["Manual"] = "MANUAL";
    B2cCampaignOfferType["Retention"] = "RETENTION";
    B2cCampaignOfferType["Unknown"] = "UNKNOWN";
    B2cCampaignOfferType["UpSell"] = "UP_SELL";
    B2cCampaignOfferType["Vario"] = "VARIO";
    B2cCampaignOfferType["WinBack"] = "WIN_BACK";
    return B2cCampaignOfferType;
}({});
export var B2cChangeOrigins = /*#__PURE__*/ function(B2cChangeOrigins) {
    B2cChangeOrigins["Customer"] = "CUSTOMER";
    B2cChangeOrigins["CustomerService"] = "CUSTOMER_SERVICE";
    B2cChangeOrigins["System"] = "SYSTEM";
    return B2cChangeOrigins;
}({});
export var B2cFixedPriceType = /*#__PURE__*/ function(B2cFixedPriceType) {
    B2cFixedPriceType["FixedPriceTypeEnergy"] = "FIXED_PRICE_TYPE_ENERGY";
    B2cFixedPriceType["FixedPriceTypeFix"] = "FIXED_PRICE_TYPE_FIX";
    B2cFixedPriceType["FixedPriceTypeGoodwill"] = "FIXED_PRICE_TYPE_GOODWILL";
    B2cFixedPriceType["GuaranteeDate"] = "GUARANTEE_DATE";
    B2cFixedPriceType["GuaranteeDateFix"] = "GUARANTEE_DATE_FIX";
    B2cFixedPriceType["GuaranteeDateFullPriceExcludingVat"] = "GUARANTEE_DATE_FULL_PRICE_EXCLUDING_VAT";
    B2cFixedPriceType["GuaranteeDateFullPriceIncludingVatAndNewTaxes"] = "GUARANTEE_DATE_FULL_PRICE_INCLUDING_VAT_AND_NEW_TAXES";
    B2cFixedPriceType["GuaranteeDateGoodwill"] = "GUARANTEE_DATE_GOODWILL";
    B2cFixedPriceType["GuaranteeMonths"] = "GUARANTEE_MONTHS";
    B2cFixedPriceType["GuaranteeMonthsFix"] = "GUARANTEE_MONTHS_FIX";
    B2cFixedPriceType["GuaranteeMonthsFullPriceExcludingVat"] = "GUARANTEE_MONTHS_FULL_PRICE_EXCLUDING_VAT";
    B2cFixedPriceType["GuaranteeMonthsFullPriceIncludingVatAndNewTaxes"] = "GUARANTEE_MONTHS_FULL_PRICE_INCLUDING_VAT_AND_NEW_TAXES";
    B2cFixedPriceType["GuaranteeMonthsGoodwill"] = "GUARANTEE_MONTHS_GOODWILL";
    B2cFixedPriceType["None"] = "NONE";
    B2cFixedPriceType["Unknown"] = "UNKNOWN";
    return B2cFixedPriceType;
}({});
export var B2cOrderHouseType = /*#__PURE__*/ function(B2cOrderHouseType) {
    B2cOrderHouseType["ApartmentBuilding"] = "APARTMENT_BUILDING";
    B2cOrderHouseType["Detached"] = "DETACHED";
    B2cOrderHouseType["TwoFamily"] = "TWO_FAMILY";
    return B2cOrderHouseType;
}({});
export var B2cPeriodUnit = /*#__PURE__*/ function(B2cPeriodUnit) {
    B2cPeriodUnit["Days"] = "DAYS";
    B2cPeriodUnit["Months"] = "MONTHS";
    B2cPeriodUnit["Unknown"] = "UNKNOWN";
    B2cPeriodUnit["Weeks"] = "WEEKS";
    B2cPeriodUnit["Years"] = "YEARS";
    return B2cPeriodUnit;
}({});
export var B2cReadingOrigin = /*#__PURE__*/ function(B2cReadingOrigin) {
    B2cReadingOrigin["ByCarrier"] = "BY_CARRIER";
    B2cReadingOrigin["ByCustomer"] = "BY_CUSTOMER";
    B2cReadingOrigin["Calculated"] = "CALCULATED";
    B2cReadingOrigin["Other"] = "OTHER";
    B2cReadingOrigin["PreviousProvider"] = "PREVIOUS_PROVIDER";
    B2cReadingOrigin["ThirdParty"] = "THIRD_PARTY";
    return B2cReadingOrigin;
}({});
export var B2cReadingQualifier = /*#__PURE__*/ function(B2cReadingQualifier) {
    B2cReadingQualifier["Estimated"] = "ESTIMATED";
    B2cReadingQualifier["ForeCast"] = "FORE_CAST";
    B2cReadingQualifier["Other"] = "OTHER";
    B2cReadingQualifier["Read"] = "READ";
    B2cReadingQualifier["Suggested"] = "SUGGESTED";
    B2cReadingQualifier["Sum"] = "SUM";
    B2cReadingQualifier["Unknown"] = "UNKNOWN";
    return B2cReadingQualifier;
}({});
export var B2cReadingTypes = /*#__PURE__*/ function(B2cReadingTypes) {
    B2cReadingTypes["CounterBegin"] = "COUNTER_BEGIN";
    B2cReadingTypes["CounterEnd"] = "COUNTER_END";
    B2cReadingTypes["Cycle"] = "CYCLE";
    B2cReadingTypes["Estimation"] = "ESTIMATION";
    B2cReadingTypes["IntermediateEstimation"] = "INTERMEDIATE_ESTIMATION";
    B2cReadingTypes["InBetween"] = "IN_BETWEEN";
    B2cReadingTypes["Manual"] = "MANUAL";
    B2cReadingTypes["MeterAssembly"] = "METER_ASSEMBLY";
    B2cReadingTypes["MeterDisassembly"] = "METER_DISASSEMBLY";
    B2cReadingTypes["MovingIn"] = "MOVING_IN";
    B2cReadingTypes["MovingOut"] = "MOVING_OUT";
    B2cReadingTypes["NotSpecified"] = "NOT_SPECIFIED";
    B2cReadingTypes["Unknown"] = "UNKNOWN";
    return B2cReadingTypes;
}({});
export var B2cRelocationAddressTransfer = /*#__PURE__*/ function(B2cRelocationAddressTransfer) {
    B2cRelocationAddressTransfer["Instant"] = "INSTANT";
    B2cRelocationAddressTransfer["None"] = "NONE";
    B2cRelocationAddressTransfer["OnArrival"] = "ON_ARRIVAL";
    return B2cRelocationAddressTransfer;
}({});
export var B2cTerminationReason = /*#__PURE__*/ function(B2cTerminationReason) {
    B2cTerminationReason["BetterOffer"] = "BETTER_OFFER";
    B2cTerminationReason["Death"] = "DEATH";
    B2cTerminationReason["DifferentTariffDesired"] = "DIFFERENT_TARIFF_DESIRED";
    B2cTerminationReason["MoveAbroad"] = "MOVE_ABROAD";
    B2cTerminationReason["MoveExistingContract"] = "MOVE_EXISTING_CONTRACT";
    B2cTerminationReason["MoveIntoSharedHousehold"] = "MOVE_INTO_SHARED_HOUSEHOLD";
    B2cTerminationReason["MoveNoDeliveryAddress"] = "MOVE_NO_DELIVERY_ADDRESS";
    B2cTerminationReason["MoveToCareFacility"] = "MOVE_TO_CARE_FACILITY";
    B2cTerminationReason["MoveToNewAddress"] = "MOVE_TO_NEW_ADDRESS";
    B2cTerminationReason["NotSatisfied"] = "NOT_SATISFIED";
    B2cTerminationReason["NoElectricHeatingConnectionAtNewAddress"] = "NO_ELECTRIC_HEATING_CONNECTION_AT_NEW_ADDRESS";
    B2cTerminationReason["NoGasConnectionAtNewAddress"] = "NO_GAS_CONNECTION_AT_NEW_ADDRESS";
    B2cTerminationReason["NoReason"] = "NO_REASON";
    B2cTerminationReason["OtherProvider"] = "OTHER_PROVIDER";
    B2cTerminationReason["PriceAdjustment"] = "PRICE_ADJUSTMENT";
    return B2cTerminationReason;
}({});
export var B2cTerminationType = /*#__PURE__*/ function(B2cTerminationType) {
    B2cTerminationType["Regular"] = "REGULAR";
    B2cTerminationType["Relocation"] = "RELOCATION";
    B2cTerminationType["Special"] = "SPECIAL";
    return B2cTerminationType;
}({});
export var BonusCategory = /*#__PURE__*/ function(BonusCategory) {
    BonusCategory["Flex"] = "FLEX";
    BonusCategory["Instant"] = "INSTANT";
    BonusCategory["None"] = "NONE";
    BonusCategory["Regular"] = "REGULAR";
    return BonusCategory;
}({});
export var BonusType = /*#__PURE__*/ function(BonusType) {
    BonusType["FlexAbsolute"] = "FLEX_ABSOLUTE";
    BonusType["FlexPercentage"] = "FLEX_PERCENTAGE";
    BonusType["None"] = "NONE";
    BonusType["Regular"] = "REGULAR";
    BonusType["Unknown"] = "UNKNOWN";
    return BonusType;
}({});
export var BonusUnit = /*#__PURE__*/ function(BonusUnit) {
    BonusUnit["Euro"] = "EURO";
    BonusUnit["None"] = "NONE";
    BonusUnit["Percent"] = "PERCENT";
    return BonusUnit;
}({});
export var BuildingType = /*#__PURE__*/ function(BuildingType) {
    BuildingType["Detached"] = "DETACHED";
    BuildingType["MidTerrace"] = "MID_TERRACE";
    BuildingType["SemiDetached"] = "SEMI_DETACHED";
    return BuildingType;
}({});
export var CampaignOfferType = /*#__PURE__*/ function(CampaignOfferType) {
    CampaignOfferType["Contractextensionoffer"] = "CONTRACTEXTENSIONOFFER";
    CampaignOfferType["Crosssell"] = "CROSSSELL";
    CampaignOfferType["Manual"] = "MANUAL";
    CampaignOfferType["Retention"] = "RETENTION";
    CampaignOfferType["Unknown"] = "UNKNOWN";
    CampaignOfferType["Upsell"] = "UPSELL";
    CampaignOfferType["Vario"] = "VARIO";
    CampaignOfferType["Winback"] = "WINBACK";
    return CampaignOfferType;
}({});
export var CancellationPeriodType = /*#__PURE__*/ function(CancellationPeriodType) {
    CancellationPeriodType["Days"] = "DAYS";
    CancellationPeriodType["Months"] = "MONTHS";
    CancellationPeriodType["Weeks"] = "WEEKS";
    return CancellationPeriodType;
}({});
export var Capabilities = /*#__PURE__*/ function(Capabilities) {
    Capabilities["CreditCardPayable"] = "CREDIT_CARD_PAYABLE";
    Capabilities["FreeParking"] = "FREE_PARKING";
    Capabilities["Manual"] = "MANUAL";
    Capabilities["NativeApp"] = "NATIVE_APP";
    Capabilities["Nfc"] = "NFC";
    Capabilities["Other"] = "OTHER";
    Capabilities["QrCode"] = "QR_CODE";
    Capabilities["ReducedParking"] = "REDUCED_PARKING";
    Capabilities["ReferToCounter"] = "REFER_TO_COUNTER";
    Capabilities["RemoteStartStop"] = "REMOTE_START_STOP";
    Capabilities["RentalCarsOnly"] = "RENTAL_CARS_ONLY";
    Capabilities["Reservable"] = "RESERVABLE";
    Capabilities["Rfid"] = "RFID";
    Capabilities["Roofed"] = "ROOFED";
    Capabilities["SmsConfirmation"] = "SMS_CONFIRMATION";
    return Capabilities;
}({});
export var Categories = /*#__PURE__*/ function(Categories) {
    Categories["Article"] = "ARTICLE";
    Categories["Dynamictariff"] = "DYNAMICTARIFF";
    Categories["Eaas"] = "EAAS";
    Categories["Fahrstrom"] = "FAHRSTROM";
    Categories["Gas"] = "GAS";
    Categories["Heatpump"] = "HEATPUMP";
    Categories["Power"] = "POWER";
    Categories["Power2Car"] = "POWER2CAR";
    Categories["Service"] = "SERVICE";
    Categories["Spot"] = "SPOT";
    Categories["Storageheater"] = "STORAGEHEATER";
    Categories["Unknown"] = "UNKNOWN";
    return Categories;
}({});
export var Category = /*#__PURE__*/ function(Category) {
    Category["Fast"] = "FAST";
    Category["Slow"] = "SLOW";
    Category["Unknown"] = "UNKNOWN";
    return Category;
}({});
export var ChangeBankAccountPayloadError = /*#__PURE__*/ function(ChangeBankAccountPayloadError) {
    /** Ungültige Vertragsnummer */ ChangeBankAccountPayloadError["Invalidcontractid"] = "INVALIDCONTRACTID";
    /** Ungültige IBAN */ ChangeBankAccountPayloadError["Invalidiban"] = "INVALIDIBAN";
    /** Unbekannter Fehler */ ChangeBankAccountPayloadError["Undefined"] = "UNDEFINED";
    return ChangeBankAccountPayloadError;
}({});
export var ChangeBillingAddressPayloadError = /*#__PURE__*/ function(ChangeBillingAddressPayloadError) {
    /** Fehler in einem der Felder */ ChangeBillingAddressPayloadError["Fielderror"] = "FIELDERROR";
    /** Wert hat die falsche Länge */ ChangeBillingAddressPayloadError["Invalidlength"] = "INVALIDLENGTH";
    /** Parameter hat ungültigen Wert */ ChangeBillingAddressPayloadError["Invalidvalue"] = "INVALIDVALUE";
    /** Unbekannter Fehler */ ChangeBillingAddressPayloadError["Undefined"] = "UNDEFINED";
    /** Wert fehlt */ ChangeBillingAddressPayloadError["Valuenotset"] = "VALUENOTSET";
    return ChangeBillingAddressPayloadError;
}({});
export var ChangeDepositNotAllowedReason = /*#__PURE__*/ function(ChangeDepositNotAllowedReason) {
    ChangeDepositNotAllowedReason["Finished"] = "FINISHED";
    ChangeDepositNotAllowedReason["IsVario"] = "IS_VARIO";
    ChangeDepositNotAllowedReason["WaitingForDelivery"] = "WAITING_FOR_DELIVERY";
    return ChangeDepositNotAllowedReason;
}({});
export var ChangeDepositPayloadError = /*#__PURE__*/ function(ChangeDepositPayloadError) {
    /** Unbekannter Fehler */ ChangeDepositPayloadError["Undefined"] = "UNDEFINED";
    return ChangeDepositPayloadError;
}({});
export var ChangeOrigins = /*#__PURE__*/ function(ChangeOrigins) {
    ChangeOrigins["Customer"] = "CUSTOMER";
    ChangeOrigins["Customerservice"] = "CUSTOMERSERVICE";
    ChangeOrigins["System"] = "SYSTEM";
    return ChangeOrigins;
}({});
export var ChangePasswordErrorType = /*#__PURE__*/ function(ChangePasswordErrorType) {
    ChangePasswordErrorType["InvalidUsernameOrPassword"] = "INVALID_USERNAME_OR_PASSWORD";
    ChangePasswordErrorType["None"] = "NONE";
    return ChangePasswordErrorType;
}({});
export var ChargeLogStatus = /*#__PURE__*/ function(ChargeLogStatus) {
    ChargeLogStatus["FailedToStart"] = "FAILED_TO_START";
    ChargeLogStatus["FailedToStop"] = "FAILED_TO_STOP";
    ChargeLogStatus["Started"] = "STARTED";
    ChargeLogStatus["Starting"] = "STARTING";
    ChargeLogStatus["Stopped"] = "STOPPED";
    ChargeLogStatus["Stopping"] = "STOPPING";
    ChargeLogStatus["Unknown"] = "UNKNOWN";
    return ChargeLogStatus;
}({});
export var ChargingScheduleStatus = /*#__PURE__*/ function(ChargingScheduleStatus) {
    ChargingScheduleStatus["Active"] = "ACTIVE";
    ChargingScheduleStatus["Disabled"] = "DISABLED";
    ChargingScheduleStatus["Pending"] = "PENDING";
    ChargingScheduleStatus["Requested"] = "REQUESTED";
    ChargingScheduleStatus["Unknown"] = "UNKNOWN";
    return ChargingScheduleStatus;
}({});
export var ChargingTransactionStatus = /*#__PURE__*/ function(ChargingTransactionStatus) {
    ChargingTransactionStatus["ChargingStarted"] = "CHARGING_STARTED";
    ChargingTransactionStatus["Finished"] = "FINISHED";
    ChargingTransactionStatus["Plugged"] = "PLUGGED";
    ChargingTransactionStatus["Unknown"] = "UNKNOWN";
    return ChargingTransactionStatus;
}({});
export var CollectStopChargingErrorFeedbackErrorType = /*#__PURE__*/ function(CollectStopChargingErrorFeedbackErrorType) {
    CollectStopChargingErrorFeedbackErrorType["ChargeDetailRecordNotFound"] = "CHARGE_DETAIL_RECORD_NOT_FOUND";
    CollectStopChargingErrorFeedbackErrorType["HtbChargeLogNotFound"] = "HTB_CHARGE_LOG_NOT_FOUND";
    CollectStopChargingErrorFeedbackErrorType["None"] = "NONE";
    CollectStopChargingErrorFeedbackErrorType["UserNotFound"] = "USER_NOT_FOUND";
    return CollectStopChargingErrorFeedbackErrorType;
}({});
export var CommodityContractStatus = /*#__PURE__*/ function(CommodityContractStatus) {
    CommodityContractStatus["Active"] = "ACTIVE";
    CommodityContractStatus["CancellationPreviousProvider"] = "CANCELLATION_PREVIOUS_PROVIDER";
    CommodityContractStatus["DeliveryNet"] = "DELIVERY_NET";
    CommodityContractStatus["Expired"] = "EXPIRED";
    CommodityContractStatus["Open"] = "OPEN";
    CommodityContractStatus["Revoked"] = "REVOKED";
    CommodityContractStatus["Terminated"] = "TERMINATED";
    CommodityContractStatus["Unknown"] = "UNKNOWN";
    CommodityContractStatus["Waiting"] = "WAITING";
    return CommodityContractStatus;
}({});
export var ConfirmOrderPayloadError = /*#__PURE__*/ function(ConfirmOrderPayloadError) {
    ConfirmOrderPayloadError["Undefined"] = "UNDEFINED";
    return ConfirmOrderPayloadError;
}({});
export var ConnectorStatus = /*#__PURE__*/ function(ConnectorStatus) {
    ConnectorStatus["Available"] = "AVAILABLE";
    ConnectorStatus["Charging"] = "CHARGING";
    ConnectorStatus["Outoforder"] = "OUTOFORDER";
    ConnectorStatus["Reserved"] = "RESERVED";
    ConnectorStatus["Unknown"] = "UNKNOWN";
    return ConnectorStatus;
}({});
export var ConsumptionGranularity = /*#__PURE__*/ function(ConsumptionGranularity) {
    ConsumptionGranularity["Daily"] = "DAILY";
    ConsumptionGranularity["Hourly"] = "HOURLY";
    ConsumptionGranularity["Monthly"] = "MONTHLY";
    ConsumptionGranularity["QuarterHour"] = "QUARTER_HOUR";
    return ConsumptionGranularity;
}({});
export var ConsumptionType = /*#__PURE__*/ function(ConsumptionType) {
    ConsumptionType["HeatPump"] = "HEAT_PUMP";
    ConsumptionType["HouseholdElectricity"] = "HOUSEHOLD_ELECTRICITY";
    ConsumptionType["HouseholdElectricityAndHeatPump"] = "HOUSEHOLD_ELECTRICITY_AND_HEAT_PUMP";
    ConsumptionType["HouseholdElectricityAndStorageHeater"] = "HOUSEHOLD_ELECTRICITY_AND_STORAGE_HEATER";
    ConsumptionType["None"] = "NONE";
    ConsumptionType["NonCommodity"] = "NON_COMMODITY";
    ConsumptionType["StorageHeater"] = "STORAGE_HEATER";
    ConsumptionType["Universal"] = "UNIVERSAL";
    ConsumptionType["Unknown"] = "UNKNOWN";
    return ConsumptionType;
}({});
export var ContactFormReasonType = /*#__PURE__*/ function(ContactFormReasonType) {
    /** @deprecated Accessibility is removed from the contact reasons. */ ContactFormReasonType["Accessibility"] = "ACCESSIBILITY";
    ContactFormReasonType["AdvancePayment"] = "ADVANCE_PAYMENT";
    ContactFormReasonType["AppFeedbackWishes"] = "APP_FEEDBACK_WISHES";
    ContactFormReasonType["CombinedHeatPowerOffshoreLevy"] = "COMBINED_HEAT_POWER_OFFSHORE_LEVY";
    ContactFormReasonType["DataProtection"] = "DATA_PROTECTION";
    ContactFormReasonType["Electromobility"] = "ELECTROMOBILITY";
    ContactFormReasonType["GasAndElectricityPriceCap"] = "GAS_AND_ELECTRICITY_PRICE_CAP";
    ContactFormReasonType["Invoice"] = "INVOICE";
    ContactFormReasonType["MeterReading"] = "METER_READING";
    ContactFormReasonType["MyData"] = "MY_DATA";
    ContactFormReasonType["Other"] = "OTHER";
    ContactFormReasonType["PriceAdjustment"] = "PRICE_ADJUSTMENT";
    ContactFormReasonType["Relocation"] = "RELOCATION";
    ContactFormReasonType["Reminder"] = "REMINDER";
    ContactFormReasonType["Revocation"] = "REVOCATION";
    ContactFormReasonType["SolarPackageAndPowerWallet"] = "SOLAR_PACKAGE_AND_POWER_WALLET";
    ContactFormReasonType["SubmitFinalBill"] = "SUBMIT_FINAL_BILL";
    ContactFormReasonType["TariffAndContract"] = "TARIFF_AND_CONTRACT";
    ContactFormReasonType["TariffChangeNet"] = "TARIFF_CHANGE_NET";
    ContactFormReasonType["TechProblems"] = "TECH_PROBLEMS";
    ContactFormReasonType["Termination"] = "TERMINATION";
    return ContactFormReasonType;
}({});
export var ContactFormReasonsStatus = /*#__PURE__*/ function(ContactFormReasonsStatus) {
    ContactFormReasonsStatus["Error"] = "ERROR";
    ContactFormReasonsStatus["Success"] = "SUCCESS";
    return ContactFormReasonsStatus;
}({});
export var ContactPermissionStatus = /*#__PURE__*/ function(ContactPermissionStatus) {
    ContactPermissionStatus["Error"] = "ERROR";
    ContactPermissionStatus["Success"] = "SUCCESS";
    ContactPermissionStatus["Unknown"] = "UNKNOWN";
    return ContactPermissionStatus;
}({});
export var ContactReasonFieldType = /*#__PURE__*/ function(ContactReasonFieldType) {
    ContactReasonFieldType["ContractId"] = "CONTRACT_ID";
    ContactReasonFieldType["FileUpload"] = "FILE_UPLOAD";
    ContactReasonFieldType["Message"] = "MESSAGE";
    return ContactReasonFieldType;
}({});
export var ContractPriceTariffTimeFrame = /*#__PURE__*/ function(ContractPriceTariffTimeFrame) {
    ContractPriceTariffTimeFrame["Anytime"] = "ANYTIME";
    ContractPriceTariffTimeFrame["Unknown"] = "UNKNOWN";
    return ContractPriceTariffTimeFrame;
}({});
export var ContractStatus = /*#__PURE__*/ function(ContractStatus) {
    ContractStatus["Active"] = "ACTIVE";
    ContractStatus["Blocked"] = "BLOCKED";
    ContractStatus["Cancellationpreviousprovider"] = "CANCELLATIONPREVIOUSPROVIDER";
    ContractStatus["Cancelled"] = "CANCELLED";
    ContractStatus["Deliverynet"] = "DELIVERYNET";
    ContractStatus["Done"] = "DONE";
    ContractStatus["Expired"] = "EXPIRED";
    ContractStatus["Open"] = "OPEN";
    ContractStatus["Revoked"] = "REVOKED";
    ContractStatus["Terminated"] = "TERMINATED";
    ContractStatus["Unknown"] = "UNKNOWN";
    ContractStatus["Waiting"] = "WAITING";
    return ContractStatus;
}({});
export var ContractStatusBadge = /*#__PURE__*/ function(ContractStatusBadge) {
    ContractStatusBadge["Expired"] = "EXPIRED";
    ContractStatusBadge["InDelivery"] = "IN_DELIVERY";
    ContractStatusBadge["InProgress"] = "IN_PROGRESS";
    ContractStatusBadge["Relocated"] = "RELOCATED";
    ContractStatusBadge["RelocationConfirmed"] = "RELOCATION_CONFIRMED";
    ContractStatusBadge["Revoked"] = "REVOKED";
    ContractStatusBadge["Terminated"] = "TERMINATED";
    ContractStatusBadge["Unknown"] = "UNKNOWN";
    ContractStatusBadge["WaitingForDelivery"] = "WAITING_FOR_DELIVERY";
    return ContractStatusBadge;
}({});
export var ContractStatusChangingReason = /*#__PURE__*/ function(ContractStatusChangingReason) {
    ContractStatusChangingReason["Activating"] = "ACTIVATING";
    ContractStatusChangingReason["Cancelling"] = "CANCELLING";
    ContractStatusChangingReason["Relocating"] = "RELOCATING";
    ContractStatusChangingReason["Revoking"] = "REVOKING";
    ContractStatusChangingReason["Terminating"] = "TERMINATING";
    ContractStatusChangingReason["Unknown"] = "UNKNOWN";
    return ContractStatusChangingReason;
}({});
export var CostItemType = /*#__PURE__*/ function(CostItemType) {
    CostItemType["CpoCosts"] = "CPO_COSTS";
    CostItemType["Custom"] = "CUSTOM";
    CostItemType["DurationMinute"] = "DURATION_MINUTE";
    CostItemType["Energy"] = "ENERGY";
    CostItemType["Flat"] = "FLAT";
    CostItemType["Service"] = "SERVICE";
    CostItemType["TariffCalcChargingTimeCosts"] = "TARIFF_CALC_CHARGING_TIME_COSTS";
    CostItemType["TariffCalcEnergyCosts"] = "TARIFF_CALC_ENERGY_COSTS";
    CostItemType["TariffCalcFlatCosts"] = "TARIFF_CALC_FLAT_COSTS";
    CostItemType["TariffCalcIdleTimeCosts"] = "TARIFF_CALC_IDLE_TIME_COSTS";
    CostItemType["TariffCalcReservationCosts"] = "TARIFF_CALC_RESERVATION_COSTS";
    CostItemType["UnKnown"] = "UN_KNOWN";
    return CostItemType;
}({});
export var CounterType = /*#__PURE__*/ function(CounterType) {
    CounterType["Etz"] = "ETZ";
    CounterType["Ntz"] = "NTZ";
    CounterType["Unknown"] = "UNKNOWN";
    CounterType["Ztz"] = "ZTZ";
    return CounterType;
}({});
export var CreateOrderStatus = /*#__PURE__*/ function(CreateOrderStatus) {
    CreateOrderStatus["Ok"] = "OK";
    return CreateOrderStatus;
}({});
export var CreateRelocationOrderPayloadError = /*#__PURE__*/ function(CreateRelocationOrderPayloadError) {
    CreateRelocationOrderPayloadError["Contractcannotberelocated"] = "CONTRACTCANNOTBERELOCATED";
    CreateRelocationOrderPayloadError["Fielderrors"] = "FIELDERRORS";
    CreateRelocationOrderPayloadError["Invalidpastdate"] = "INVALIDPASTDATE";
    CreateRelocationOrderPayloadError["Invalidusage"] = "INVALIDUSAGE";
    CreateRelocationOrderPayloadError["Missingvalue"] = "MISSINGVALUE";
    CreateRelocationOrderPayloadError["Unknown"] = "UNKNOWN";
    CreateRelocationOrderPayloadError["Unknowncity"] = "UNKNOWNCITY";
    return CreateRelocationOrderPayloadError;
}({});
export var CurrentEaasSubscriptionDataErrorType = /*#__PURE__*/ function(CurrentEaasSubscriptionDataErrorType) {
    CurrentEaasSubscriptionDataErrorType["IncompleteData"] = "INCOMPLETE_DATA";
    CurrentEaasSubscriptionDataErrorType["None"] = "NONE";
    CurrentEaasSubscriptionDataErrorType["UnhandledError"] = "UNHANDLED_ERROR";
    return CurrentEaasSubscriptionDataErrorType;
}({});
export var CustomerContactFormStatus = /*#__PURE__*/ function(CustomerContactFormStatus) {
    CustomerContactFormStatus["Contractmissing"] = "CONTRACTMISSING";
    CustomerContactFormStatus["Error"] = "ERROR";
    CustomerContactFormStatus["Honeypot"] = "HONEYPOT";
    CustomerContactFormStatus["Invalidparameters"] = "INVALIDPARAMETERS";
    CustomerContactFormStatus["Limitexceeded"] = "LIMITEXCEEDED";
    CustomerContactFormStatus["Success"] = "SUCCESS";
    return CustomerContactFormStatus;
}({});
export var CustomerSpecification = /*#__PURE__*/ function(CustomerSpecification) {
    CustomerSpecification["DesiredDate"] = "DESIRED_DATE";
    CustomerSpecification["EarliestPossibleDate"] = "EARLIEST_POSSIBLE_DATE";
    CustomerSpecification["RelocationAt"] = "RELOCATION_AT";
    CustomerSpecification["TerminatedInPerson"] = "TERMINATED_IN_PERSON";
    return CustomerSpecification;
}({});
export var CustomerSpecifications = /*#__PURE__*/ function(CustomerSpecifications) {
    CustomerSpecifications["Basicsupplyregistration"] = "BASICSUPPLYREGISTRATION";
    CustomerSpecifications["Desireddate"] = "DESIREDDATE";
    CustomerSpecifications["Earliestpossibledate"] = "EARLIESTPOSSIBLEDATE";
    CustomerSpecifications["Relocationat"] = "RELOCATIONAT";
    CustomerSpecifications["Relocationwithoutmako"] = "RELOCATIONWITHOUTMAKO";
    CustomerSpecifications["Substitutesupplyregistration"] = "SUBSTITUTESUPPLYREGISTRATION";
    CustomerSpecifications["Terminatedinperson"] = "TERMINATEDINPERSON";
    CustomerSpecifications["Unknown"] = "UNKNOWN";
    return CustomerSpecifications;
}({});
export var DeleteUserAccountStatus = /*#__PURE__*/ function(DeleteUserAccountStatus) {
    DeleteUserAccountStatus["Ok"] = "OK";
    return DeleteUserAccountStatus;
}({});
export var DesiredTimeOfInstallation = /*#__PURE__*/ function(DesiredTimeOfInstallation) {
    DesiredTimeOfInstallation["In1_3Months"] = "IN1_3_MONTHS";
    DesiredTimeOfInstallation["In4_6Months"] = "IN4_6_MONTHS";
    DesiredTimeOfInstallation["In6MonthsAtTheEarliest"] = "IN6_MONTHS_AT_THE_EARLIEST";
    DesiredTimeOfInstallation["NextAvailableTime"] = "NEXT_AVAILABLE_TIME";
    return DesiredTimeOfInstallation;
}({});
export var DisbursementType = /*#__PURE__*/ function(DisbursementType) {
    DisbursementType["Onetime"] = "ONETIME";
    DisbursementType["Permanent"] = "PERMANENT";
    return DisbursementType;
}({});
export var EaasEnergyContractTypePayload = /*#__PURE__*/ function(EaasEnergyContractTypePayload) {
    EaasEnergyContractTypePayload["DynamicPro"] = "DYNAMIC_PRO";
    EaasEnergyContractTypePayload["None"] = "NONE";
    EaasEnergyContractTypePayload["Other"] = "OTHER";
    EaasEnergyContractTypePayload["Vario"] = "VARIO";
    return EaasEnergyContractTypePayload;
}({});
export var EaasPaymentType = /*#__PURE__*/ function(EaasPaymentType) {
    EaasPaymentType["BankTransfer"] = "BANK_TRANSFER";
    EaasPaymentType["DirectDebit"] = "DIRECT_DEBIT";
    EaasPaymentType["Undefined"] = "UNDEFINED";
    return EaasPaymentType;
}({});
export var EaasStromWalletActivationStatusPayload = /*#__PURE__*/ function(EaasStromWalletActivationStatusPayload) {
    EaasStromWalletActivationStatusPayload["MeterConfigured"] = "METER_CONFIGURED";
    EaasStromWalletActivationStatusPayload["SwitchedToDynamic"] = "SWITCHED_TO_DYNAMIC";
    EaasStromWalletActivationStatusPayload["SwitchedToVario"] = "SWITCHED_TO_VARIO";
    EaasStromWalletActivationStatusPayload["Undefined"] = "UNDEFINED";
    EaasStromWalletActivationStatusPayload["WaitingForVarioConfirmation"] = "WAITING_FOR_VARIO_CONFIRMATION";
    return EaasStromWalletActivationStatusPayload;
}({});
export var EaasStromWalletPackagePayload = /*#__PURE__*/ function(EaasStromWalletPackagePayload) {
    EaasStromWalletPackagePayload["SolarPaketLight"] = "SOLAR_PAKET_LIGHT";
    EaasStromWalletPackagePayload["SolarPaketString"] = "SOLAR_PAKET_STRING";
    EaasStromWalletPackagePayload["StromWallet1"] = "STROM_WALLET1";
    EaasStromWalletPackagePayload["StromWallet2"] = "STROM_WALLET2";
    EaasStromWalletPackagePayload["StromWalletOnly"] = "STROM_WALLET_ONLY";
    EaasStromWalletPackagePayload["StromWalletUpsell"] = "STROM_WALLET_UPSELL";
    EaasStromWalletPackagePayload["Undefined"] = "UNDEFINED";
    return EaasStromWalletPackagePayload;
}({});
export var EaasSubscriptionStatus = /*#__PURE__*/ function(EaasSubscriptionStatus) {
    EaasSubscriptionStatus["Active"] = "ACTIVE";
    EaasSubscriptionStatus["Inactive"] = "INACTIVE";
    EaasSubscriptionStatus["Unknown"] = "UNKNOWN";
    return EaasSubscriptionStatus;
}({});
export var EaasUserType = /*#__PURE__*/ function(EaasUserType) {
    EaasUserType["ActivatedEaasUser"] = "ACTIVATED_EAAS_USER";
    EaasUserType["NotActivatedEaasUser"] = "NOT_ACTIVATED_EAAS_USER";
    EaasUserType["NotEaasUser"] = "NOT_EAAS_USER";
    return EaasUserType;
}({});
export var EeecActivateChargeCardResultType = /*#__PURE__*/ function(EeecActivateChargeCardResultType) {
    EeecActivateChargeCardResultType["ChargeCardIsAlreadyAssigned"] = "CHARGE_CARD_IS_ALREADY_ASSIGNED";
    EeecActivateChargeCardResultType["Failed"] = "FAILED";
    EeecActivateChargeCardResultType["InvalidEvcoId"] = "INVALID_EVCO_ID";
    EeecActivateChargeCardResultType["Success"] = "SUCCESS";
    EeecActivateChargeCardResultType["UserNotFound"] = "USER_NOT_FOUND";
    return EeecActivateChargeCardResultType;
}({});
export var EeecActivateTokenResultType = /*#__PURE__*/ function(EeecActivateTokenResultType) {
    EeecActivateTokenResultType["Failed"] = "FAILED";
    EeecActivateTokenResultType["InvalidEvcoId"] = "INVALID_EVCO_ID";
    EeecActivateTokenResultType["Success"] = "SUCCESS";
    EeecActivateTokenResultType["TokenIsAlreadyAssigned"] = "TOKEN_IS_ALREADY_ASSIGNED";
    EeecActivateTokenResultType["UserNotFound"] = "USER_NOT_FOUND";
    return EeecActivateTokenResultType;
}({});
export var EeecAddFavouriteResult = /*#__PURE__*/ function(EeecAddFavouriteResult) {
    EeecAddFavouriteResult["Error"] = "ERROR";
    EeecAddFavouriteResult["LocationAlreadyInFavourites"] = "LOCATION_ALREADY_IN_FAVOURITES";
    EeecAddFavouriteResult["Success"] = "SUCCESS";
    return EeecAddFavouriteResult;
}({});
export var EeecConnectorPowerType = /*#__PURE__*/ function(EeecConnectorPowerType) {
    EeecConnectorPowerType["Ac_1Phase"] = "AC_1_PHASE";
    EeecConnectorPowerType["Ac_2Phase"] = "AC_2_PHASE";
    EeecConnectorPowerType["Ac_2PhaseSplit"] = "AC_2_PHASE_SPLIT";
    EeecConnectorPowerType["Ac_3Phase"] = "AC_3_PHASE";
    EeecConnectorPowerType["Dc"] = "DC";
    return EeecConnectorPowerType;
}({});
export var EeecConnectorStandard = /*#__PURE__*/ function(EeecConnectorStandard) {
    EeecConnectorStandard["Chademo"] = "CHADEMO";
    EeecConnectorStandard["Chaoji"] = "CHAOJI";
    EeecConnectorStandard["DomesticA"] = "DOMESTIC_A";
    EeecConnectorStandard["DomesticB"] = "DOMESTIC_B";
    EeecConnectorStandard["DomesticC"] = "DOMESTIC_C";
    EeecConnectorStandard["DomesticD"] = "DOMESTIC_D";
    EeecConnectorStandard["DomesticE"] = "DOMESTIC_E";
    EeecConnectorStandard["DomesticF"] = "DOMESTIC_F";
    EeecConnectorStandard["DomesticG"] = "DOMESTIC_G";
    EeecConnectorStandard["DomesticH"] = "DOMESTIC_H";
    EeecConnectorStandard["DomesticI"] = "DOMESTIC_I";
    EeecConnectorStandard["DomesticJ"] = "DOMESTIC_J";
    EeecConnectorStandard["DomesticK"] = "DOMESTIC_K";
    EeecConnectorStandard["DomesticL"] = "DOMESTIC_L";
    EeecConnectorStandard["DomesticM"] = "DOMESTIC_M";
    EeecConnectorStandard["DomesticN"] = "DOMESTIC_N";
    EeecConnectorStandard["DomesticO"] = "DOMESTIC_O";
    EeecConnectorStandard["GbtAc"] = "GBT_AC";
    EeecConnectorStandard["GbtDc"] = "GBT_DC";
    EeecConnectorStandard["Iec_60309_2Single_16"] = "IEC_60309_2_SINGLE_16";
    EeecConnectorStandard["Iec_60309_2Three_16"] = "IEC_60309_2_THREE_16";
    EeecConnectorStandard["Iec_60309_2Three_32"] = "IEC_60309_2_THREE_32";
    EeecConnectorStandard["Iec_60309_2Three_64"] = "IEC_60309_2_THREE_64";
    EeecConnectorStandard["Iec_62196T1"] = "IEC_62196_T1";
    EeecConnectorStandard["Iec_62196T1Combo"] = "IEC_62196_T1_COMBO";
    EeecConnectorStandard["Iec_62196T2"] = "IEC_62196_T2";
    EeecConnectorStandard["Iec_62196T2Combo"] = "IEC_62196_T2_COMBO";
    EeecConnectorStandard["Iec_62196T3A"] = "IEC_62196_T3A";
    EeecConnectorStandard["Iec_62196T3C"] = "IEC_62196_T3C";
    EeecConnectorStandard["Mcs"] = "MCS";
    EeecConnectorStandard["Nema_5_20"] = "NEMA_5_20";
    EeecConnectorStandard["Nema_6_30"] = "NEMA_6_30";
    EeecConnectorStandard["Nema_6_50"] = "NEMA_6_50";
    EeecConnectorStandard["Nema_10_30"] = "NEMA_10_30";
    EeecConnectorStandard["Nema_10_50"] = "NEMA_10_50";
    EeecConnectorStandard["Nema_14_30"] = "NEMA_14_30";
    EeecConnectorStandard["Nema_14_50"] = "NEMA_14_50";
    EeecConnectorStandard["PantographBottomUp"] = "PANTOGRAPH_BOTTOM_UP";
    EeecConnectorStandard["PantographTopDown"] = "PANTOGRAPH_TOP_DOWN";
    EeecConnectorStandard["SaeJ3400"] = "SAE_J3400";
    EeecConnectorStandard["TeslaR"] = "TESLA_R";
    EeecConnectorStandard["TeslaS"] = "TESLA_S";
    return EeecConnectorStandard;
}({});
export var EeecConnectorStandardType = /*#__PURE__*/ function(EeecConnectorStandardType) {
    EeecConnectorStandardType["Ccs"] = "CCS";
    EeecConnectorStandardType["Chademo"] = "CHADEMO";
    EeecConnectorStandardType["Other"] = "OTHER";
    EeecConnectorStandardType["Type2"] = "TYPE2";
    return EeecConnectorStandardType;
}({});
export var EeecCreateEDriverResultType = /*#__PURE__*/ function(EeecCreateEDriverResultType) {
    EeecCreateEDriverResultType["InvalidSource"] = "INVALID_SOURCE";
    EeecCreateEDriverResultType["NewUserRegistrationNotAllowed"] = "NEW_USER_REGISTRATION_NOT_ALLOWED";
    EeecCreateEDriverResultType["UserAlreadyExists"] = "USER_ALREADY_EXISTS";
    EeecCreateEDriverResultType["UserBlocked"] = "USER_BLOCKED";
    EeecCreateEDriverResultType["UserCreatedWithSsoSupport"] = "USER_CREATED_WITH_SSO_SUPPORT";
    EeecCreateEDriverResultType["UserCreationFailed"] = "USER_CREATION_FAILED";
    EeecCreateEDriverResultType["UserCreationInitiated"] = "USER_CREATION_INITIATED";
    return EeecCreateEDriverResultType;
}({});
export var EeecDayOfWeek = /*#__PURE__*/ function(EeecDayOfWeek) {
    EeecDayOfWeek["Friday"] = "FRIDAY";
    EeecDayOfWeek["Monday"] = "MONDAY";
    EeecDayOfWeek["Saturday"] = "SATURDAY";
    EeecDayOfWeek["Sunday"] = "SUNDAY";
    EeecDayOfWeek["Thursday"] = "THURSDAY";
    EeecDayOfWeek["Tuesday"] = "TUESDAY";
    EeecDayOfWeek["Wednesday"] = "WEDNESDAY";
    return EeecDayOfWeek;
}({});
export var EeecEmailVerificationResultType = /*#__PURE__*/ function(EeecEmailVerificationResultType) {
    EeecEmailVerificationResultType["AlreadyVerified"] = "ALREADY_VERIFIED";
    EeecEmailVerificationResultType["BusinessEmailNotSet"] = "BUSINESS_EMAIL_NOT_SET";
    EeecEmailVerificationResultType["InvalidVerificationCode"] = "INVALID_VERIFICATION_CODE";
    EeecEmailVerificationResultType["OperationNotAllowed"] = "OPERATION_NOT_ALLOWED";
    EeecEmailVerificationResultType["Success"] = "SUCCESS";
    EeecEmailVerificationResultType["UserNotFound"] = "USER_NOT_FOUND";
    return EeecEmailVerificationResultType;
}({});
export var EeecEvseStatus = /*#__PURE__*/ function(EeecEvseStatus) {
    EeecEvseStatus["Available"] = "AVAILABLE";
    EeecEvseStatus["Blocked"] = "BLOCKED";
    EeecEvseStatus["Charging"] = "CHARGING";
    EeecEvseStatus["Inoperative"] = "INOPERATIVE";
    EeecEvseStatus["Outoforder"] = "OUTOFORDER";
    EeecEvseStatus["Planned"] = "PLANNED";
    EeecEvseStatus["Removed"] = "REMOVED";
    EeecEvseStatus["Reserved"] = "RESERVED";
    EeecEvseStatus["Unknown"] = "UNKNOWN";
    return EeecEvseStatus;
}({});
export var EeecExtendAccountValidityStatus = /*#__PURE__*/ function(EeecExtendAccountValidityStatus) {
    EeecExtendAccountValidityStatus["Error"] = "ERROR";
    EeecExtendAccountValidityStatus["NotFound"] = "NOT_FOUND";
    EeecExtendAccountValidityStatus["Success"] = "SUCCESS";
    EeecExtendAccountValidityStatus["ValidationError"] = "VALIDATION_ERROR";
    return EeecExtendAccountValidityStatus;
}({});
export var EeecFinalizeOnboardingResultType = /*#__PURE__*/ function(EeecFinalizeOnboardingResultType) {
    EeecFinalizeOnboardingResultType["Failed"] = "FAILED";
    EeecFinalizeOnboardingResultType["OperationNotAllowed"] = "OPERATION_NOT_ALLOWED";
    EeecFinalizeOnboardingResultType["Success"] = "SUCCESS";
    return EeecFinalizeOnboardingResultType;
}({});
export var EeecHomeChargeSessionVehicleType = /*#__PURE__*/ function(EeecHomeChargeSessionVehicleType) {
    EeecHomeChargeSessionVehicleType["CompanyVehicle"] = "COMPANY_VEHICLE";
    EeecHomeChargeSessionVehicleType["PrivateVehicle"] = "PRIVATE_VEHICLE";
    return EeecHomeChargeSessionVehicleType;
}({});
export var EeecHomeWallboxType = /*#__PURE__*/ function(EeecHomeWallboxType) {
    EeecHomeWallboxType["PassThrough"] = "PASS_THROUGH";
    EeecHomeWallboxType["Reimbursement"] = "REIMBURSEMENT";
    return EeecHomeWallboxType;
}({});
export var EeecMileageLogCreationResponse = /*#__PURE__*/ function(EeecMileageLogCreationResponse) {
    EeecMileageLogCreationResponse["FailureMileageLogLowerThanLastLog"] = "FAILURE_MILEAGE_LOG_LOWER_THAN_LAST_LOG";
    EeecMileageLogCreationResponse["FailureVehicleDoesNotBelongToUser"] = "FAILURE_VEHICLE_DOES_NOT_BELONG_TO_USER";
    EeecMileageLogCreationResponse["FailureVehicleNotFound"] = "FAILURE_VEHICLE_NOT_FOUND";
    EeecMileageLogCreationResponse["Success"] = "SUCCESS";
    return EeecMileageLogCreationResponse;
}({});
export var EeecOrderResultType = /*#__PURE__*/ function(EeecOrderResultType) {
    EeecOrderResultType["CompanyDoesNotAllowChargeCardOrders"] = "COMPANY_DOES_NOT_ALLOW_CHARGE_CARD_ORDERS";
    EeecOrderResultType["Error"] = "ERROR";
    EeecOrderResultType["InvalidData"] = "INVALID_DATA";
    EeecOrderResultType["Success"] = "SUCCESS";
    EeecOrderResultType["UserDisabled"] = "USER_DISABLED";
    EeecOrderResultType["UserNotFound"] = "USER_NOT_FOUND";
    return EeecOrderResultType;
}({});
export var EeecQrCodeScanResponseResultType = /*#__PURE__*/ function(EeecQrCodeScanResponseResultType) {
    EeecQrCodeScanResponseResultType["EvseFoundAndServed"] = "EVSE_FOUND_AND_SERVED";
    EeecQrCodeScanResponseResultType["EvseNotFound"] = "EVSE_NOT_FOUND";
    EeecQrCodeScanResponseResultType["KnownInvalidString"] = "KNOWN_INVALID_STRING";
    EeecQrCodeScanResponseResultType["NoEvseFoundInUrl"] = "NO_EVSE_FOUND_IN_URL";
    EeecQrCodeScanResponseResultType["OperatorNotServed"] = "OPERATOR_NOT_SERVED";
    return EeecQrCodeScanResponseResultType;
}({});
export var EeecReimbursementTariffChangeRequestStatus = /*#__PURE__*/ function(EeecReimbursementTariffChangeRequestStatus) {
    EeecReimbursementTariffChangeRequestStatus["Approved"] = "APPROVED";
    EeecReimbursementTariffChangeRequestStatus["Pending"] = "PENDING";
    EeecReimbursementTariffChangeRequestStatus["Rejected"] = "REJECTED";
    return EeecReimbursementTariffChangeRequestStatus;
}({});
export var EeecReimbursementTariffCreationStatus = /*#__PURE__*/ function(EeecReimbursementTariffCreationStatus) {
    EeecReimbursementTariffCreationStatus["DocumentNotFound"] = "DOCUMENT_NOT_FOUND";
    EeecReimbursementTariffCreationStatus["DocumentProcessingPleaseRetry"] = "DOCUMENT_PROCESSING_PLEASE_RETRY";
    EeecReimbursementTariffCreationStatus["DocumentRejected"] = "DOCUMENT_REJECTED";
    EeecReimbursementTariffCreationStatus["Error"] = "ERROR";
    EeecReimbursementTariffCreationStatus["MissingDocumentBlobId"] = "MISSING_DOCUMENT_BLOB_ID";
    EeecReimbursementTariffCreationStatus["Success"] = "SUCCESS";
    return EeecReimbursementTariffCreationStatus;
}({});
export var EeecRemoveFavouriteResult = /*#__PURE__*/ function(EeecRemoveFavouriteResult) {
    EeecRemoveFavouriteResult["Error"] = "ERROR";
    EeecRemoveFavouriteResult["LocationNotInFavourites"] = "LOCATION_NOT_IN_FAVOURITES";
    EeecRemoveFavouriteResult["Success"] = "SUCCESS";
    return EeecRemoveFavouriteResult;
}({});
export var EeecRequiredAction = /*#__PURE__*/ function(EeecRequiredAction) {
    EeecRequiredAction["None"] = "NONE";
    EeecRequiredAction["ProvideBusinessEmail"] = "PROVIDE_BUSINESS_EMAIL";
    EeecRequiredAction["ProvideContractualDetails"] = "PROVIDE_CONTRACTUAL_DETAILS";
    EeecRequiredAction["ProvideLeasingContractDetails"] = "PROVIDE_LEASING_CONTRACT_DETAILS";
    EeecRequiredAction["RenewAccount"] = "RENEW_ACCOUNT";
    EeecRequiredAction["SelectCarCustomerGroup"] = "SELECT_CAR_CUSTOMER_GROUP";
    EeecRequiredAction["SelectUserGroup"] = "SELECT_USER_GROUP";
    EeecRequiredAction["TriggerOnboardingFinalization"] = "TRIGGER_ONBOARDING_FINALIZATION";
    EeecRequiredAction["VerifyBusinessEmail"] = "VERIFY_BUSINESS_EMAIL";
    EeecRequiredAction["WaitForHrApproval"] = "WAIT_FOR_HR_APPROVAL";
    EeecRequiredAction["WaitForOnboardingCompletion"] = "WAIT_FOR_ONBOARDING_COMPLETION";
    return EeecRequiredAction;
}({});
export var EeecResendUserAccountRenewalNotificationResultType = /*#__PURE__*/ function(EeecResendUserAccountRenewalNotificationResultType) {
    EeecResendUserAccountRenewalNotificationResultType["Error"] = "ERROR";
    EeecResendUserAccountRenewalNotificationResultType["RenewalNotRequired"] = "RENEWAL_NOT_REQUIRED";
    EeecResendUserAccountRenewalNotificationResultType["Success"] = "SUCCESS";
    return EeecResendUserAccountRenewalNotificationResultType;
}({});
export var EeecRestartOnboardingResponse = /*#__PURE__*/ function(EeecRestartOnboardingResponse) {
    EeecRestartOnboardingResponse["Failure"] = "FAILURE";
    EeecRestartOnboardingResponse["OperationNotAllowed"] = "OPERATION_NOT_ALLOWED";
    EeecRestartOnboardingResponse["Success"] = "SUCCESS";
    return EeecRestartOnboardingResponse;
}({});
export var EeecSessionStatus = /*#__PURE__*/ function(EeecSessionStatus) {
    EeecSessionStatus["Active"] = "ACTIVE";
    EeecSessionStatus["Completed"] = "COMPLETED";
    EeecSessionStatus["Invalid"] = "INVALID";
    EeecSessionStatus["Pending"] = "PENDING";
    EeecSessionStatus["Unknown"] = "UNKNOWN";
    return EeecSessionStatus;
}({});
export var EeecStartSessionResultType = /*#__PURE__*/ function(EeecStartSessionResultType) {
    EeecStartSessionResultType["Error"] = "ERROR";
    EeecStartSessionResultType["EvseNotFound"] = "EVSE_NOT_FOUND";
    EeecStartSessionResultType["EvseNotRemoteStartStopCapable"] = "EVSE_NOT_REMOTE_START_STOP_CAPABLE";
    EeecStartSessionResultType["EvseUnavailable"] = "EVSE_UNAVAILABLE";
    EeecStartSessionResultType["InvalidSubscription"] = "INVALID_SUBSCRIPTION";
    EeecStartSessionResultType["Success"] = "SUCCESS";
    EeecStartSessionResultType["UserDisabledOrNotFound"] = "USER_DISABLED_OR_NOT_FOUND";
    return EeecStartSessionResultType;
}({});
export var EeecStepBackOnboardingResponse = /*#__PURE__*/ function(EeecStepBackOnboardingResponse) {
    EeecStepBackOnboardingResponse["Failure"] = "FAILURE";
    EeecStepBackOnboardingResponse["OperationNotAllowed"] = "OPERATION_NOT_ALLOWED";
    EeecStepBackOnboardingResponse["Success"] = "SUCCESS";
    return EeecStepBackOnboardingResponse;
}({});
export var EeecStopSessionResultType = /*#__PURE__*/ function(EeecStopSessionResultType) {
    EeecStopSessionResultType["Error"] = "ERROR";
    EeecStopSessionResultType["EvseUnavailable"] = "EVSE_UNAVAILABLE";
    EeecStopSessionResultType["SessionNotFound"] = "SESSION_NOT_FOUND";
    EeecStopSessionResultType["Success"] = "SUCCESS";
    EeecStopSessionResultType["UnknownSession"] = "UNKNOWN_SESSION";
    EeecStopSessionResultType["UserInvalidOrNotFound"] = "USER_INVALID_OR_NOT_FOUND";
    return EeecStopSessionResultType;
}({});
export var EeecTariffPowerType = /*#__PURE__*/ function(EeecTariffPowerType) {
    EeecTariffPowerType["Ac"] = "AC";
    EeecTariffPowerType["Dc"] = "DC";
    return EeecTariffPowerType;
}({});
export var EeecUpdateResultType = /*#__PURE__*/ function(EeecUpdateResultType) {
    EeecUpdateResultType["Error"] = "ERROR";
    EeecUpdateResultType["InvalidData"] = "INVALID_DATA";
    EeecUpdateResultType["NotFound"] = "NOT_FOUND";
    EeecUpdateResultType["OperationNotAllowed"] = "OPERATION_NOT_ALLOWED";
    EeecUpdateResultType["Success"] = "SUCCESS";
    return EeecUpdateResultType;
}({});
export var EeecUpdateUserLocaleResponse = /*#__PURE__*/ function(EeecUpdateUserLocaleResponse) {
    EeecUpdateUserLocaleResponse["InvalidLocaleCode"] = "INVALID_LOCALE_CODE";
    EeecUpdateUserLocaleResponse["Success"] = "SUCCESS";
    EeecUpdateUserLocaleResponse["UserNotFound"] = "USER_NOT_FOUND";
    return EeecUpdateUserLocaleResponse;
}({});
export var EeecUserAccountRenewalResponse = /*#__PURE__*/ function(EeecUserAccountRenewalResponse) {
    EeecUserAccountRenewalResponse["AccountNotRenewable"] = "ACCOUNT_NOT_RENEWABLE";
    EeecUserAccountRenewalResponse["Error"] = "ERROR";
    EeecUserAccountRenewalResponse["InvalidVerificationCode"] = "INVALID_VERIFICATION_CODE";
    EeecUserAccountRenewalResponse["Success"] = "SUCCESS";
    return EeecUserAccountRenewalResponse;
}({});
export var EeecUserGroup = /*#__PURE__*/ function(EeecUserGroup) {
    EeecUserGroup["LeasingDriver"] = "LEASING_DRIVER";
    EeecUserGroup["PrivateEmployee"] = "PRIVATE_EMPLOYEE";
    return EeecUserGroup;
}({});
export var EeecUserOrderStatus = /*#__PURE__*/ function(EeecUserOrderStatus) {
    EeecUserOrderStatus["Approved"] = "APPROVED";
    EeecUserOrderStatus["InProduction"] = "IN_PRODUCTION";
    EeecUserOrderStatus["Ordered"] = "ORDERED";
    EeecUserOrderStatus["Produced"] = "PRODUCED";
    EeecUserOrderStatus["Shipped"] = "SHIPPED";
    return EeecUserOrderStatus;
}({});
export var EeecVehicleCreationResponse = /*#__PURE__*/ function(EeecVehicleCreationResponse) {
    EeecVehicleCreationResponse["FailureAssignmentPeriodEndBeforeStart"] = "FAILURE_ASSIGNMENT_PERIOD_END_BEFORE_START";
    EeecVehicleCreationResponse["FailureLicensePlateOccupiedWithinAssignmentPeriod"] = "FAILURE_LICENSE_PLATE_OCCUPIED_WITHIN_ASSIGNMENT_PERIOD";
    EeecVehicleCreationResponse["FailureUserNotAuthorizedToAddVehicles"] = "FAILURE_USER_NOT_AUTHORIZED_TO_ADD_VEHICLES";
    EeecVehicleCreationResponse["FailureUserNotFound"] = "FAILURE_USER_NOT_FOUND";
    EeecVehicleCreationResponse["Success"] = "SUCCESS";
    return EeecVehicleCreationResponse;
}({});
export var EeecVehicleUnassignmentResponse = /*#__PURE__*/ function(EeecVehicleUnassignmentResponse) {
    EeecVehicleUnassignmentResponse["FailureVehicleDoesNotBelongToUser"] = "FAILURE_VEHICLE_DOES_NOT_BELONG_TO_USER";
    EeecVehicleUnassignmentResponse["FailureVehicleNotFound"] = "FAILURE_VEHICLE_NOT_FOUND";
    EeecVehicleUnassignmentResponse["Success"] = "SUCCESS";
    return EeecVehicleUnassignmentResponse;
}({});
export var EmobilityContractStatus = /*#__PURE__*/ function(EmobilityContractStatus) {
    EmobilityContractStatus["Active"] = "ACTIVE";
    EmobilityContractStatus["Expired"] = "EXPIRED";
    EmobilityContractStatus["Open"] = "OPEN";
    EmobilityContractStatus["Revoked"] = "REVOKED";
    EmobilityContractStatus["Terminated"] = "TERMINATED";
    EmobilityContractStatus["Unknown"] = "UNKNOWN";
    return EmobilityContractStatus;
}({});
export var EmobilityTariffType = /*#__PURE__*/ function(EmobilityTariffType) {
    EmobilityTariffType["BlockingDurationFast"] = "BLOCKING_DURATION_FAST";
    EmobilityTariffType["BlockingDurationSlow"] = "BLOCKING_DURATION_SLOW";
    EmobilityTariffType["BlockingFeeFast"] = "BLOCKING_FEE_FAST";
    EmobilityTariffType["BlockingFeeSlow"] = "BLOCKING_FEE_SLOW";
    EmobilityTariffType["Fast"] = "FAST";
    EmobilityTariffType["Slow"] = "SLOW";
    return EmobilityTariffType;
}({});
export var Energy = /*#__PURE__*/ function(Energy) {
    Energy["Electricity"] = "ELECTRICITY";
    Energy["Gas"] = "GAS";
    Energy["None"] = "NONE";
    return Energy;
}({});
export var EnergyContractType = /*#__PURE__*/ function(EnergyContractType) {
    EnergyContractType["DynamicPro"] = "DYNAMIC_PRO";
    EnergyContractType["None"] = "NONE";
    EnergyContractType["Other"] = "OTHER";
    EnergyContractType["Vario"] = "VARIO";
    return EnergyContractType;
}({});
export var EnergyCostAidStatus = /*#__PURE__*/ function(EnergyCostAidStatus) {
    EnergyCostAidStatus["Calculated"] = "CALCULATED";
    EnergyCostAidStatus["Notapplicable"] = "NOTAPPLICABLE";
    EnergyCostAidStatus["Unknown"] = "UNKNOWN";
    return EnergyCostAidStatus;
}({});
export var EnergyInput = /*#__PURE__*/ function(EnergyInput) {
    EnergyInput["Electricity"] = "ELECTRICITY";
    EnergyInput["Gas"] = "GAS";
    return EnergyInput;
}({});
export var EnergySystemHardwareType = /*#__PURE__*/ function(EnergySystemHardwareType) {
    EnergySystemHardwareType["Accessory"] = "ACCESSORY";
    EnergySystemHardwareType["BatteryAndAccessory"] = "BATTERY_AND_ACCESSORY";
    EnergySystemHardwareType["Cable"] = "CABLE";
    EnergySystemHardwareType["EnergyManagement"] = "ENERGY_MANAGEMENT";
    EnergySystemHardwareType["Heatpump"] = "HEATPUMP";
    EnergySystemHardwareType["Inverter"] = "INVERTER";
    EnergySystemHardwareType["Other"] = "OTHER";
    EnergySystemHardwareType["SolarModule"] = "SOLAR_MODULE";
    EnergySystemHardwareType["Wallbox"] = "WALLBOX";
    return EnergySystemHardwareType;
}({});
export var EvseChargingLogic = /*#__PURE__*/ function(EvseChargingLogic) {
    EvseChargingLogic["MaxPower"] = "MAX_POWER";
    EvseChargingLogic["Schedule"] = "SCHEDULE";
    return EvseChargingLogic;
}({});
export var EvseChargingMode = /*#__PURE__*/ function(EvseChargingMode) {
    EvseChargingMode["Changing"] = "CHANGING";
    EvseChargingMode["Managed"] = "MANAGED";
    EvseChargingMode["PlugAndCharge"] = "PLUG_AND_CHARGE";
    EvseChargingMode["Unknown"] = "UNKNOWN";
    return EvseChargingMode;
}({});
export var ExtensionTimeType = /*#__PURE__*/ function(ExtensionTimeType) {
    ExtensionTimeType["Days"] = "DAYS";
    ExtensionTimeType["Months"] = "MONTHS";
    ExtensionTimeType["Weeks"] = "WEEKS";
    return ExtensionTimeType;
}({});
export var FixedPriceType = /*#__PURE__*/ function(FixedPriceType) {
    FixedPriceType["Fixedpricetypeenergy"] = "FIXEDPRICETYPEENERGY";
    FixedPriceType["Fixedpricetypefix"] = "FIXEDPRICETYPEFIX";
    FixedPriceType["Fixedpricetypegoodwill"] = "FIXEDPRICETYPEGOODWILL";
    FixedPriceType["Guaranteedate"] = "GUARANTEEDATE";
    FixedPriceType["Guaranteedatefix"] = "GUARANTEEDATEFIX";
    FixedPriceType["Guaranteedatefullpriceexcludingvat"] = "GUARANTEEDATEFULLPRICEEXCLUDINGVAT";
    FixedPriceType["Guaranteedatefullpriceincludingvatandnewtaxes"] = "GUARANTEEDATEFULLPRICEINCLUDINGVATANDNEWTAXES";
    FixedPriceType["Guaranteedategoodwill"] = "GUARANTEEDATEGOODWILL";
    FixedPriceType["Guaranteemonths"] = "GUARANTEEMONTHS";
    FixedPriceType["Guaranteemonthsfix"] = "GUARANTEEMONTHSFIX";
    FixedPriceType["Guaranteemonthsfullpriceexcludingvat"] = "GUARANTEEMONTHSFULLPRICEEXCLUDINGVAT";
    FixedPriceType["Guaranteemonthsfullpriceincludingvatandnewtaxes"] = "GUARANTEEMONTHSFULLPRICEINCLUDINGVATANDNEWTAXES";
    FixedPriceType["Guaranteemonthsgoodwill"] = "GUARANTEEMONTHSGOODWILL";
    FixedPriceType["None"] = "NONE";
    FixedPriceType["Unknown"] = "UNKNOWN";
    return FixedPriceType;
}({});
export var HardwareTypeEnum = /*#__PURE__*/ function(HardwareTypeEnum) {
    HardwareTypeEnum["Accessory"] = "ACCESSORY";
    HardwareTypeEnum["BatteryAndAccessory"] = "BATTERY_AND_ACCESSORY";
    HardwareTypeEnum["Cable"] = "CABLE";
    HardwareTypeEnum["EnergyManagement"] = "ENERGY_MANAGEMENT";
    HardwareTypeEnum["HeatPump"] = "HEAT_PUMP";
    HardwareTypeEnum["Inverter"] = "INVERTER";
    HardwareTypeEnum["Other"] = "OTHER";
    HardwareTypeEnum["SolarModule"] = "SOLAR_MODULE";
    HardwareTypeEnum["Undefined"] = "UNDEFINED";
    HardwareTypeEnum["Wallbox"] = "WALLBOX";
    return HardwareTypeEnum;
}({});
export var HeatEmissionTypeInput = /*#__PURE__*/ function(HeatEmissionTypeInput) {
    HeatEmissionTypeInput["Other"] = "OTHER";
    HeatEmissionTypeInput["Radiator"] = "RADIATOR";
    HeatEmissionTypeInput["RadiatorAndUnderfloorHeating"] = "RADIATOR_AND_UNDERFLOOR_HEATING";
    HeatEmissionTypeInput["UnderfloorHeating"] = "UNDERFLOOR_HEATING";
    return HeatEmissionTypeInput;
}({});
export var HeatingFuelTypeInput = /*#__PURE__*/ function(HeatingFuelTypeInput) {
    HeatingFuelTypeInput["Gas"] = "GAS";
    HeatingFuelTypeInput["Heatpump"] = "HEATPUMP";
    HeatingFuelTypeInput["Oil"] = "OIL";
    HeatingFuelTypeInput["Other"] = "OTHER";
    HeatingFuelTypeInput["Pellet"] = "PELLET";
    return HeatingFuelTypeInput;
}({});
export var HighConsuptionTime = /*#__PURE__*/ function(HighConsuptionTime) {
    HighConsuptionTime["AllDay"] = "ALL_DAY";
    HighConsuptionTime["MorningAndAfternoon"] = "MORNING_AND_AFTERNOON";
    return HighConsuptionTime;
}({});
export var HouseType = /*#__PURE__*/ function(HouseType) {
    HouseType["ApartmentBuilding"] = "APARTMENT_BUILDING";
    HouseType["CommercialBuilding"] = "COMMERCIAL_BUILDING";
    HouseType["Detached"] = "DETACHED";
    HouseType["Terraced"] = "TERRACED";
    HouseType["TwoFamily"] = "TWO_FAMILY";
    return HouseType;
}({});
export var LbEvseStatus = /*#__PURE__*/ function(LbEvseStatus) {
    LbEvseStatus["Available"] = "AVAILABLE";
    LbEvseStatus["Charging"] = "CHARGING";
    LbEvseStatus["Completed"] = "COMPLETED";
    LbEvseStatus["Connected"] = "CONNECTED";
    LbEvseStatus["Error"] = "ERROR";
    LbEvseStatus["Fake"] = "FAKE";
    LbEvseStatus["Starting"] = "STARTING";
    LbEvseStatus["Stopping"] = "STOPPING";
    LbEvseStatus["Suspended"] = "SUSPENDED";
    LbEvseStatus["Unavailable"] = "UNAVAILABLE";
    return LbEvseStatus;
}({});
export var MessageType = /*#__PURE__*/ function(MessageType) {
    MessageType["All"] = "ALL";
    MessageType["Communication"] = "COMMUNICATION";
    MessageType["Invoice"] = "INVOICE";
    return MessageType;
}({});
export var MinimumRuntimeType = /*#__PURE__*/ function(MinimumRuntimeType) {
    MinimumRuntimeType["Days"] = "DAYS";
    MinimumRuntimeType["Months"] = "MONTHS";
    return MinimumRuntimeType;
}({});
export var OrderHouseType = /*#__PURE__*/ function(OrderHouseType) {
    OrderHouseType["Apartmentbuilding"] = "APARTMENTBUILDING";
    OrderHouseType["Detached"] = "DETACHED";
    OrderHouseType["Twofamily"] = "TWOFAMILY";
    return OrderHouseType;
}({});
export var OrderStatus = /*#__PURE__*/ function(OrderStatus) {
    OrderStatus["Blocked"] = "BLOCKED";
    OrderStatus["Cancelled"] = "CANCELLED";
    OrderStatus["Check"] = "CHECK";
    OrderStatus["Confirmed"] = "CONFIRMED";
    OrderStatus["Done"] = "DONE";
    OrderStatus["Expired"] = "EXPIRED";
    OrderStatus["Open"] = "OPEN";
    OrderStatus["Rejected"] = "REJECTED";
    OrderStatus["Revoked"] = "REVOKED";
    OrderStatus["Unknown"] = "UNKNOWN";
    OrderStatus["Waiting"] = "WAITING";
    return OrderStatus;
}({});
export var Origins = /*#__PURE__*/ function(Origins) {
    Origins["Admin"] = "ADMIN";
    Origins["Anonymize"] = "ANONYMIZE";
    Origins["Backgroundservices"] = "BACKGROUNDSERVICES";
    Origins["Customerservice"] = "CUSTOMERSERVICE";
    Origins["Monitoring"] = "MONITORING";
    Origins["Others"] = "OTHERS";
    Origins["Unknown"] = "UNKNOWN";
    Origins["Webservicegateway"] = "WEBSERVICEGATEWAY";
    return Origins;
}({});
export var PeriodUnit = /*#__PURE__*/ function(PeriodUnit) {
    PeriodUnit["Days"] = "DAYS";
    PeriodUnit["Months"] = "MONTHS";
    PeriodUnit["Unknown"] = "UNKNOWN";
    PeriodUnit["Weeks"] = "WEEKS";
    PeriodUnit["Years"] = "YEARS";
    return PeriodUnit;
}({});
export var Platform = /*#__PURE__*/ function(Platform) {
    Platform["Android"] = "ANDROID";
    Platform["Ios"] = "IOS";
    Platform["Unknown"] = "UNKNOWN";
    return Platform;
}({});
export var PowerCloudContractStatusPayload = /*#__PURE__*/ function(PowerCloudContractStatusPayload) {
    PowerCloudContractStatusPayload["Blocked"] = "BLOCKED";
    PowerCloudContractStatusPayload["Canceled"] = "CANCELED";
    PowerCloudContractStatusPayload["ChangeProcessNb"] = "CHANGE_PROCESS_NB";
    PowerCloudContractStatusPayload["Completed"] = "COMPLETED";
    PowerCloudContractStatusPayload["Expired"] = "EXPIRED";
    PowerCloudContractStatusPayload["InDelivery"] = "IN_DELIVERY";
    PowerCloudContractStatusPayload["None"] = "NONE";
    PowerCloudContractStatusPayload["Open"] = "OPEN";
    PowerCloudContractStatusPayload["Terminated"] = "TERMINATED";
    PowerCloudContractStatusPayload["TerminationLfa"] = "TERMINATION_LFA";
    PowerCloudContractStatusPayload["WaitingForDelivery"] = "WAITING_FOR_DELIVERY";
    return PowerCloudContractStatusPayload;
}({});
export var PowerCloudContractType = /*#__PURE__*/ function(PowerCloudContractType) {
    PowerCloudContractType["Energy"] = "ENERGY";
    PowerCloudContractType["FeedIn"] = "FEED_IN";
    PowerCloudContractType["Hardware"] = "HARDWARE";
    PowerCloudContractType["None"] = "NONE";
    return PowerCloudContractType;
}({});
export var PowerCloudContractTypePayload = /*#__PURE__*/ function(PowerCloudContractTypePayload) {
    PowerCloudContractTypePayload["Energy"] = "ENERGY";
    PowerCloudContractTypePayload["FeedIn"] = "FEED_IN";
    PowerCloudContractTypePayload["Hardware"] = "HARDWARE";
    return PowerCloudContractTypePayload;
}({});
export var PowerCloudGridFeeModule = /*#__PURE__*/ function(PowerCloudGridFeeModule) {
    PowerCloudGridFeeModule["Module1"] = "MODULE1";
    PowerCloudGridFeeModule["Module2"] = "MODULE2";
    PowerCloudGridFeeModule["Module3"] = "MODULE3";
    return PowerCloudGridFeeModule;
}({});
export var PriceCapStatus = /*#__PURE__*/ function(PriceCapStatus) {
    PriceCapStatus["HighUsage"] = "HIGH_USAGE";
    PriceCapStatus["LowWorkingPrice"] = "LOW_WORKING_PRICE";
    PriceCapStatus["None"] = "NONE";
    PriceCapStatus["PriceCap"] = "PRICE_CAP";
    return PriceCapStatus;
}({});
export var PriceCurveAggregation = /*#__PURE__*/ function(PriceCurveAggregation) {
    PriceCurveAggregation["Day"] = "DAY";
    PriceCurveAggregation["Month"] = "MONTH";
    PriceCurveAggregation["Year"] = "YEAR";
    return PriceCurveAggregation;
}({});
export var PriceGuarantees = /*#__PURE__*/ function(PriceGuarantees) {
    PriceGuarantees["Energy"] = "ENERGY";
    PriceGuarantees["Fix"] = "FIX";
    PriceGuarantees["GoodWill"] = "GOOD_WILL";
    PriceGuarantees["Netto"] = "NETTO";
    PriceGuarantees["NettoNetto"] = "NETTO_NETTO";
    PriceGuarantees["None"] = "NONE";
    return PriceGuarantees;
}({});
export var PriceType = /*#__PURE__*/ function(PriceType) {
    PriceType["Multi"] = "MULTI";
    PriceType["None"] = "NONE";
    PriceType["Single"] = "SINGLE";
    PriceType["Unknown"] = "UNKNOWN";
    return PriceType;
}({});
export var PushNotificationErrorType = /*#__PURE__*/ function(PushNotificationErrorType) {
    PushNotificationErrorType["Failed"] = "FAILED";
    PushNotificationErrorType["None"] = "NONE";
    return PushNotificationErrorType;
}({});
export var ReachabilityForContact = /*#__PURE__*/ function(ReachabilityForContact) {
    ReachabilityForContact["AllDay"] = "ALL_DAY";
    ReachabilityForContact["PreferredEvening"] = "PREFERRED_EVENING";
    ReachabilityForContact["PreferredMorning"] = "PREFERRED_MORNING";
    ReachabilityForContact["PreferredNoon"] = "PREFERRED_NOON";
    return ReachabilityForContact;
}({});
export var ReadingOrigin = /*#__PURE__*/ function(ReadingOrigin) {
    ReadingOrigin["Bycarrier"] = "BYCARRIER";
    ReadingOrigin["Bycustomer"] = "BYCUSTOMER";
    ReadingOrigin["Calculated"] = "CALCULATED";
    ReadingOrigin["Other"] = "OTHER";
    ReadingOrigin["Previousprovider"] = "PREVIOUSPROVIDER";
    ReadingOrigin["Thirdparty"] = "THIRDPARTY";
    return ReadingOrigin;
}({});
export var ReadingQualifier = /*#__PURE__*/ function(ReadingQualifier) {
    ReadingQualifier["Estimated"] = "ESTIMATED";
    ReadingQualifier["Forecast"] = "FORECAST";
    ReadingQualifier["Other"] = "OTHER";
    ReadingQualifier["Read"] = "READ";
    ReadingQualifier["Suggested"] = "SUGGESTED";
    ReadingQualifier["Sum"] = "SUM";
    ReadingQualifier["Unknown"] = "UNKNOWN";
    return ReadingQualifier;
}({});
export var ReadingTypes = /*#__PURE__*/ function(ReadingTypes) {
    ReadingTypes["Counterbegin"] = "COUNTERBEGIN";
    ReadingTypes["Counterend"] = "COUNTEREND";
    ReadingTypes["Cycle"] = "CYCLE";
    ReadingTypes["Estimation"] = "ESTIMATION";
    ReadingTypes["Inbetween"] = "INBETWEEN";
    ReadingTypes["Intermediateestimation"] = "INTERMEDIATEESTIMATION";
    ReadingTypes["Manual"] = "MANUAL";
    ReadingTypes["Meterassembly"] = "METERASSEMBLY";
    ReadingTypes["Meterdisassembly"] = "METERDISASSEMBLY";
    ReadingTypes["Movingin"] = "MOVINGIN";
    ReadingTypes["Movingout"] = "MOVINGOUT";
    ReadingTypes["Notspecified"] = "NOTSPECIFIED";
    ReadingTypes["Unknown"] = "UNKNOWN";
    return ReadingTypes;
}({});
export var RegisterCustomerStatus = /*#__PURE__*/ function(RegisterCustomerStatus) {
    RegisterCustomerStatus["Duplicateemail"] = "DUPLICATEEMAIL";
    RegisterCustomerStatus["Duplicateemailinad"] = "DUPLICATEEMAILINAD";
    RegisterCustomerStatus["Duplicateemailinpcl"] = "DUPLICATEEMAILINPCL";
    RegisterCustomerStatus["Error"] = "ERROR";
    RegisterCustomerStatus["Gdprlocked"] = "GDPRLOCKED";
    RegisterCustomerStatus["Invalidparameters"] = "INVALIDPARAMETERS";
    RegisterCustomerStatus["Invalidtoken"] = "INVALIDTOKEN";
    RegisterCustomerStatus["Success"] = "SUCCESS";
    return RegisterCustomerStatus;
}({});
export var RegisterCustomerWithEmailStatus = /*#__PURE__*/ function(RegisterCustomerWithEmailStatus) {
    RegisterCustomerWithEmailStatus["Duplicateemail"] = "DUPLICATEEMAIL";
    RegisterCustomerWithEmailStatus["Duplicateemailinad"] = "DUPLICATEEMAILINAD";
    RegisterCustomerWithEmailStatus["Duplicateemailinpcl"] = "DUPLICATEEMAILINPCL";
    RegisterCustomerWithEmailStatus["Error"] = "ERROR";
    RegisterCustomerWithEmailStatus["Invalidparameters"] = "INVALIDPARAMETERS";
    RegisterCustomerWithEmailStatus["Isb2B"] = "ISB2B";
    RegisterCustomerWithEmailStatus["Notfound"] = "NOTFOUND";
    RegisterCustomerWithEmailStatus["Success"] = "SUCCESS";
    return RegisterCustomerWithEmailStatus;
}({});
export var RegisterType = /*#__PURE__*/ function(RegisterType) {
    RegisterType["Ht"] = "HT";
    RegisterType["Nt"] = "NT";
    RegisterType["Unknown"] = "UNKNOWN";
    return RegisterType;
}({});
export var RelocationAddressTransfer = /*#__PURE__*/ function(RelocationAddressTransfer) {
    RelocationAddressTransfer["Instant"] = "INSTANT";
    RelocationAddressTransfer["None"] = "NONE";
    RelocationAddressTransfer["Onarrival"] = "ONARRIVAL";
    return RelocationAddressTransfer;
}({});
export var RoofAge = /*#__PURE__*/ function(RoofAge) {
    RoofAge["DontKnow"] = "DONT_KNOW";
    RoofAge["No"] = "NO";
    RoofAge["Yes"] = "YES";
    return RoofAge;
}({});
export var RoofIndication = /*#__PURE__*/ function(RoofIndication) {
    RoofIndication["Easy"] = "EASY";
    RoofIndication["Flat"] = "FLAT";
    RoofIndication["Moderate"] = "MODERATE";
    RoofIndication["Normal"] = "NORMAL";
    RoofIndication["Strong"] = "STRONG";
    RoofIndication["VeryStrong"] = "VERY_STRONG";
    return RoofIndication;
}({});
export var RoofMaterial = /*#__PURE__*/ function(RoofMaterial) {
    RoofMaterial["Asbestos"] = "ASBESTOS";
    RoofMaterial["Beavertail"] = "BEAVERTAIL";
    RoofMaterial["Brick"] = "BRICK";
    RoofMaterial["CardboardSkein"] = "CARDBOARD_SKEIN";
    RoofMaterial["CorrugatedIron"] = "CORRUGATED_IRON";
    RoofMaterial["GravelRoof"] = "GRAVEL_ROOF";
    RoofMaterial["GreenRoof"] = "GREEN_ROOF";
    RoofMaterial["Miscellaneous"] = "MISCELLANEOUS";
    RoofMaterial["Plastic"] = "PLASTIC";
    RoofMaterial["RoofingMembraneBitumen"] = "ROOFING_MEMBRANE_BITUMEN";
    RoofMaterial["Slate"] = "SLATE";
    RoofMaterial["StandingSeamSheet"] = "STANDING_SEAM_SHEET";
    RoofMaterial["TrapezoidalSheetMetal"] = "TRAPEZOIDAL_SHEET_METAL";
    return RoofMaterial;
}({});
export var RoofOrientation = /*#__PURE__*/ function(RoofOrientation) {
    RoofOrientation["East"] = "EAST";
    RoofOrientation["North"] = "NORTH";
    RoofOrientation["NorthEast"] = "NORTH_EAST";
    RoofOrientation["NorthWest"] = "NORTH_WEST";
    RoofOrientation["South"] = "SOUTH";
    RoofOrientation["SouthEast"] = "SOUTH_EAST";
    RoofOrientation["SouthWest"] = "SOUTH_WEST";
    RoofOrientation["West"] = "WEST";
    return RoofOrientation;
}({});
export var Salutation = /*#__PURE__*/ function(Salutation) {
    Salutation["Familie"] = "FAMILIE";
    Salutation["Frau"] = "FRAU";
    Salutation["Herr"] = "HERR";
    Salutation["Ohne"] = "OHNE";
    return Salutation;
}({});
export var Salutations = /*#__PURE__*/ function(Salutations) {
    Salutations["Firma"] = "FIRMA";
    Salutations["Frau"] = "FRAU";
    Salutations["Herr"] = "HERR";
    Salutations["Unknown"] = "UNKNOWN";
    return Salutations;
}({});
export var SaveFavoriteStationsErrorType = /*#__PURE__*/ function(SaveFavoriteStationsErrorType) {
    SaveFavoriteStationsErrorType["None"] = "NONE";
    SaveFavoriteStationsErrorType["UserNotFound"] = "USER_NOT_FOUND";
    return SaveFavoriteStationsErrorType;
}({});
export var ScheduleActivationStatus = /*#__PURE__*/ function(ScheduleActivationStatus) {
    ScheduleActivationStatus["Failure"] = "FAILURE";
    ScheduleActivationStatus["Success"] = "SUCCESS";
    return ScheduleActivationStatus;
}({});
export var ScheduleMissingChargeLogsImportForUserErrorType = /*#__PURE__*/ function(ScheduleMissingChargeLogsImportForUserErrorType) {
    ScheduleMissingChargeLogsImportForUserErrorType["UserNotValid"] = "USER_NOT_VALID";
    return ScheduleMissingChargeLogsImportForUserErrorType;
}({});
export var ShouldAuthenticate = /*#__PURE__*/ function(ShouldAuthenticate) {
    ShouldAuthenticate["Active"] = "ACTIVE";
    ShouldAuthenticate["No"] = "NO";
    ShouldAuthenticate["PendingConfiguration"] = "PENDING_CONFIGURATION";
    ShouldAuthenticate["RequiresAuthentication"] = "REQUIRES_AUTHENTICATION";
    return ShouldAuthenticate;
}({});
export var SolarSystemOfferCalculationStatus = /*#__PURE__*/ function(SolarSystemOfferCalculationStatus) {
    SolarSystemOfferCalculationStatus["Completed"] = "COMPLETED";
    SolarSystemOfferCalculationStatus["InProgress"] = "IN_PROGRESS";
    return SolarSystemOfferCalculationStatus;
}({});
export var SortEnumType = /*#__PURE__*/ function(SortEnumType) {
    SortEnumType["Asc"] = "ASC";
    SortEnumType["Desc"] = "DESC";
    return SortEnumType;
}({});
export var SpecialCardType = /*#__PURE__*/ function(SpecialCardType) {
    SpecialCardType["Cancellation"] = "CANCELLATION";
    SpecialCardType["DepositChange"] = "DEPOSIT_CHANGE";
    SpecialCardType["MeterReading"] = "METER_READING";
    SpecialCardType["PriceAdjustment"] = "PRICE_ADJUSTMENT";
    SpecialCardType["Relocation"] = "RELOCATION";
    SpecialCardType["Revocation"] = "REVOCATION";
    return SpecialCardType;
}({});
export var Standard = /*#__PURE__*/ function(Standard) {
    Standard["Ccs"] = "CCS";
    Standard["ChAdeMo"] = "CH_ADE_MO";
    Standard["Domestic"] = "DOMESTIC";
    Standard["Other"] = "OTHER";
    Standard["Type1"] = "TYPE1";
    Standard["Type2"] = "TYPE2";
    Standard["Type3"] = "TYPE3";
    return Standard;
}({});
export var StartChargeErrorType = /*#__PURE__*/ function(StartChargeErrorType) {
    StartChargeErrorType["AlreadyCharging"] = "ALREADY_CHARGING";
    StartChargeErrorType["CardInactive"] = "CARD_INACTIVE";
    StartChargeErrorType["None"] = "NONE";
    StartChargeErrorType["NotAllowed"] = "NOT_ALLOWED";
    StartChargeErrorType["NotFound"] = "NOT_FOUND";
    StartChargeErrorType["Other"] = "OTHER";
    StartChargeErrorType["RetryLater"] = "RETRY_LATER";
    StartChargeErrorType["Unavailable"] = "UNAVAILABLE";
    return StartChargeErrorType;
}({});
export var StartEvseChargingErrorType = /*#__PURE__*/ function(StartEvseChargingErrorType) {
    StartEvseChargingErrorType["ConnectionError"] = "CONNECTION_ERROR";
    StartEvseChargingErrorType["Failed"] = "FAILED";
    StartEvseChargingErrorType["None"] = "NONE";
    StartEvseChargingErrorType["NotFound"] = "NOT_FOUND";
    return StartEvseChargingErrorType;
}({});
export var StopChargeErrorType = /*#__PURE__*/ function(StopChargeErrorType) {
    StopChargeErrorType["ChargingNotFound"] = "CHARGING_NOT_FOUND";
    StopChargeErrorType["InactiveCard"] = "INACTIVE_CARD";
    StopChargeErrorType["None"] = "NONE";
    StopChargeErrorType["Other"] = "OTHER";
    StopChargeErrorType["RemoteStop"] = "REMOTE_STOP";
    StopChargeErrorType["Unavailable"] = "UNAVAILABLE";
    return StopChargeErrorType;
}({});
export var StopChargingErrorFeedbackType = /*#__PURE__*/ function(StopChargingErrorFeedbackType) {
    StopChargingErrorFeedbackType["ActiveOnStation"] = "ACTIVE_ON_STATION";
    StopChargingErrorFeedbackType["StoppedOnStation"] = "STOPPED_ON_STATION";
    return StopChargingErrorFeedbackType;
}({});
export var StopEvseChargingErrorType = /*#__PURE__*/ function(StopEvseChargingErrorType) {
    StopEvseChargingErrorType["ConnectionError"] = "CONNECTION_ERROR";
    StopEvseChargingErrorType["Failed"] = "FAILED";
    StopEvseChargingErrorType["None"] = "NONE";
    StopEvseChargingErrorType["NotFound"] = "NOT_FOUND";
    return StopEvseChargingErrorType;
}({});
export var StromWalletActivationStatus = /*#__PURE__*/ function(StromWalletActivationStatus) {
    StromWalletActivationStatus["MeterConfigured"] = "METER_CONFIGURED";
    StromWalletActivationStatus["SwitchedToDynamic"] = "SWITCHED_TO_DYNAMIC";
    StromWalletActivationStatus["SwitchedToVario"] = "SWITCHED_TO_VARIO";
    StromWalletActivationStatus["Undefined"] = "UNDEFINED";
    StromWalletActivationStatus["WaitingForVarioConfirmation"] = "WAITING_FOR_VARIO_CONFIRMATION";
    return StromWalletActivationStatus;
}({});
export var StromWalletActivationTask = /*#__PURE__*/ function(StromWalletActivationTask) {
    StromWalletActivationTask["ConfigureMeter"] = "CONFIGURE_METER";
    StromWalletActivationTask["SwitchToDynamic"] = "SWITCH_TO_DYNAMIC";
    StromWalletActivationTask["SwitchToVario"] = "SWITCH_TO_VARIO";
    return StromWalletActivationTask;
}({});
export var StromWalletPackage = /*#__PURE__*/ function(StromWalletPackage) {
    StromWalletPackage["SolarPaketLight"] = "SOLAR_PAKET_LIGHT";
    StromWalletPackage["SolarPaketString"] = "SOLAR_PAKET_STRING";
    StromWalletPackage["StromWallet1"] = "STROM_WALLET1";
    StromWalletPackage["StromWallet2"] = "STROM_WALLET2";
    StromWalletPackage["StromWalletOnly"] = "STROM_WALLET_ONLY";
    StromWalletPackage["StromWalletUpsell"] = "STROM_WALLET_UPSELL";
    StromWalletPackage["Undefined"] = "UNDEFINED";
    return StromWalletPackage;
}({});
export var StromWalletTaskStatus = /*#__PURE__*/ function(StromWalletTaskStatus) {
    StromWalletTaskStatus["Closed"] = "CLOSED";
    StromWalletTaskStatus["Open"] = "OPEN";
    return StromWalletTaskStatus;
}({});
export var StromWalletVersionInput = /*#__PURE__*/ function(StromWalletVersionInput) {
    StromWalletVersionInput["IsonStromWalletV2"] = "ISON_STROM_WALLET_V2";
    StromWalletVersionInput["StromWalletV2"] = "STROM_WALLET_V2";
    return StromWalletVersionInput;
}({});
export var SubmitContactFormErrorType = /*#__PURE__*/ function(SubmitContactFormErrorType) {
    SubmitContactFormErrorType["FilesRetrievalFailed"] = "FILES_RETRIEVAL_FAILED";
    SubmitContactFormErrorType["None"] = "NONE";
    SubmitContactFormErrorType["SubmissionFailed"] = "SUBMISSION_FAILED";
    SubmitContactFormErrorType["TooManyFiles"] = "TOO_MANY_FILES";
    return SubmitContactFormErrorType;
}({});
export var SubmitMeterReadingNotAllowedReason = /*#__PURE__*/ function(SubmitMeterReadingNotAllowedReason) {
    SubmitMeterReadingNotAllowedReason["Expired"] = "EXPIRED";
    SubmitMeterReadingNotAllowedReason["FinalInvoiceSubmitted"] = "FINAL_INVOICE_SUBMITTED";
    /** @deprecated Deprecated reason, don't use this! */ SubmitMeterReadingNotAllowedReason["HasSmartMeter"] = "HAS_SMART_METER";
    SubmitMeterReadingNotAllowedReason["MeterNotRegistered"] = "METER_NOT_REGISTERED";
    SubmitMeterReadingNotAllowedReason["WaitingForDelivery"] = "WAITING_FOR_DELIVERY";
    return SubmitMeterReadingNotAllowedReason;
}({});
export var SuitableForEmobilityContractProductCategories = /*#__PURE__*/ function(SuitableForEmobilityContractProductCategories) {
    SuitableForEmobilityContractProductCategories["Article"] = "ARTICLE";
    SuitableForEmobilityContractProductCategories["Dynamictariff"] = "DYNAMICTARIFF";
    SuitableForEmobilityContractProductCategories["Eaas"] = "EAAS";
    SuitableForEmobilityContractProductCategories["Fahrstrom"] = "FAHRSTROM";
    SuitableForEmobilityContractProductCategories["Gas"] = "GAS";
    SuitableForEmobilityContractProductCategories["Heatpump"] = "HEATPUMP";
    SuitableForEmobilityContractProductCategories["Power"] = "POWER";
    SuitableForEmobilityContractProductCategories["Power2Car"] = "POWER2CAR";
    SuitableForEmobilityContractProductCategories["Service"] = "SERVICE";
    SuitableForEmobilityContractProductCategories["Spot"] = "SPOT";
    SuitableForEmobilityContractProductCategories["Storageheater"] = "STORAGEHEATER";
    SuitableForEmobilityContractProductCategories["Unknown"] = "UNKNOWN";
    return SuitableForEmobilityContractProductCategories;
}({});
export var SuitableForEmobilityContractProductContractStatus = /*#__PURE__*/ function(SuitableForEmobilityContractProductContractStatus) {
    SuitableForEmobilityContractProductContractStatus["Active"] = "ACTIVE";
    SuitableForEmobilityContractProductContractStatus["Blocked"] = "BLOCKED";
    SuitableForEmobilityContractProductContractStatus["Cancellationpreviousprovider"] = "CANCELLATIONPREVIOUSPROVIDER";
    SuitableForEmobilityContractProductContractStatus["Cancelled"] = "CANCELLED";
    SuitableForEmobilityContractProductContractStatus["Deliverynet"] = "DELIVERYNET";
    SuitableForEmobilityContractProductContractStatus["Expired"] = "EXPIRED";
    SuitableForEmobilityContractProductContractStatus["Open"] = "OPEN";
    SuitableForEmobilityContractProductContractStatus["Revoked"] = "REVOKED";
    SuitableForEmobilityContractProductContractStatus["Terminated"] = "TERMINATED";
    SuitableForEmobilityContractProductContractStatus["Unknown"] = "UNKNOWN";
    SuitableForEmobilityContractProductContractStatus["Waiting"] = "WAITING";
    return SuitableForEmobilityContractProductContractStatus;
}({});
export var TriggerChangePasswordStatus = /*#__PURE__*/ function(TriggerChangePasswordStatus) {
    TriggerChangePasswordStatus["Ok"] = "OK";
    return TriggerChangePasswordStatus;
}({});
export var TriggerForgotPasswordStatus = /*#__PURE__*/ function(TriggerForgotPasswordStatus) {
    TriggerForgotPasswordStatus["Ok"] = "OK";
    return TriggerForgotPasswordStatus;
}({});
export var UpdateCustomerPayloadError = /*#__PURE__*/ function(UpdateCustomerPayloadError) {
    /** Unbekannter Fehler */ UpdateCustomerPayloadError["Undefined"] = "UNDEFINED";
    return UpdateCustomerPayloadError;
}({});
export var UpdateEvseErrorType = /*#__PURE__*/ function(UpdateEvseErrorType) {
    UpdateEvseErrorType["ConnectionError"] = "CONNECTION_ERROR";
    UpdateEvseErrorType["Failed"] = "FAILED";
    UpdateEvseErrorType["None"] = "NONE";
    UpdateEvseErrorType["NotFound"] = "NOT_FOUND";
    UpdateEvseErrorType["NotSupported"] = "NOT_SUPPORTED";
    return UpdateEvseErrorType;
}({});
export var UpdateEvseModeErrorType = /*#__PURE__*/ function(UpdateEvseModeErrorType) {
    UpdateEvseModeErrorType["EvseNotFound"] = "EVSE_NOT_FOUND";
    UpdateEvseModeErrorType["Failed"] = "FAILED";
    UpdateEvseModeErrorType["InvalidMode"] = "INVALID_MODE";
    UpdateEvseModeErrorType["None"] = "NONE";
    UpdateEvseModeErrorType["Unknown"] = "UNKNOWN";
    return UpdateEvseModeErrorType;
}({});
export var ValidateRegisterCustomerStatus = /*#__PURE__*/ function(ValidateRegisterCustomerStatus) {
    ValidateRegisterCustomerStatus["Invalidparameters"] = "INVALIDPARAMETERS";
    ValidateRegisterCustomerStatus["Isb2B"] = "ISB2B";
    ValidateRegisterCustomerStatus["Notfound"] = "NOTFOUND";
    ValidateRegisterCustomerStatus["Success"] = "SUCCESS";
    ValidateRegisterCustomerStatus["Unexpected"] = "UNEXPECTED";
    return ValidateRegisterCustomerStatus;
}({});
export var ValidateTariffChangeCodeError = /*#__PURE__*/ function(ValidateTariffChangeCodeError) {
    /** Angebot wurde bereits angenommen */ ValidateTariffChangeCodeError["Alreadyaccepted"] = "ALREADYACCEPTED";
    /** Es wurden mehrere Angebote zum selben AngebotsCode gefunden */ ValidateTariffChangeCodeError["Ambiguousoffercode"] = "AMBIGUOUSOFFERCODE";
    /** Eine Kündigung wurde ausgesprochen aber noch nicht durchgeführt */ ValidateTariffChangeCodeError["Contractcancellationrequested"] = "CONTRACTCANCELLATIONREQUESTED";
    /** Vertrag wurde gekündigt */ ValidateTariffChangeCodeError["Contractcancelled"] = "CONTRACTCANCELLED";
    /** Vertrag zum Kunden nicht vorhanden */ ValidateTariffChangeCodeError["Contractmissing"] = "CONTRACTMISSING";
    /** Parameter hat ungültigen Wert */ ValidateTariffChangeCodeError["Invalidvalue"] = "INVALIDVALUE";
    /** Angebot ist Mehrtarif */ ValidateTariffChangeCodeError["Multipletariffs"] = "MULTIPLETARIFFS";
    /** Kunde nicht vorhanden */ ValidateTariffChangeCodeError["Notmigrated"] = "NOTMIGRATED";
    /** Angebot ist nicht mehr gültig */ ValidateTariffChangeCodeError["Offerexpired"] = "OFFEREXPIRED";
    /** Anderes Angebot wurde bereits angenommen */ ValidateTariffChangeCodeError["Otherofferaccepted"] = "OTHEROFFERACCEPTED";
    /** Unbekannter Fehler */ ValidateTariffChangeCodeError["Undefined"] = "UNDEFINED";
    /** Speichern fehlgeschlagen */ ValidateTariffChangeCodeError["Updatefailed"] = "UPDATEFAILED";
    /** Wert fehlt */ ValidateTariffChangeCodeError["Valuenotset"] = "VALUENOTSET";
    return ValidateTariffChangeCodeError;
}({});
export var YearOfConstructionInput = /*#__PURE__*/ function(YearOfConstructionInput) {
    YearOfConstructionInput["After_1994"] = "AFTER_1994";
    YearOfConstructionInput["Before_1969"] = "BEFORE_1969";
    YearOfConstructionInput["NewBuilding"] = "NEW_BUILDING";
    YearOfConstructionInput["1969To_1976"] = "_1969_TO_1976";
    YearOfConstructionInput["1977To_1994"] = "_1977_TO_1994";
    return YearOfConstructionInput;
}({});
export const B2bcsCreateLeadFormDocument = gql`
  mutation B2bcsCreateLeadForm($input: B2bcsCreateLeadFormInput!) {
    b2bcsCreateLeadForm(input: $input) {
      errorType
      data {
        trackingId
      }
    }
  }
`;
export const B2bcsSubmitLeadFormDocument = gql`
  mutation B2bcsSubmitLeadForm($input: B2bcsSubmitLeadFormInput!) {
    b2bcsSubmitLeadForm(input: $input) {
      errorType
      data {
        trackingId
      }
    }
  }
`;
export const B2cAddLevyPrivilegeApplicationDocument = gql`
  mutation B2cAddLevyPrivilegeApplication($input: B2cAddLevyPrivilegeApplicationInput!) {
    b2cAddLevyPrivilegeApplication(input: $input) {
      b2cLevyPrivilegeApplicationPayload {
        contractId
        counterNumber
        emailAddress
        optIn
        optInText
      }
      errors {
        __typename
      }
    }
  }
`;
export const B2CAddCommodityLeadDocument = gql`
  mutation B2CAddCommodityLead($lead: B2CCommodityLeadInput!) {
    B2CAddCommodityLead(lead: $lead) {
      success
    }
  }
`;
export const SubmitCategorizedContactFormDocument = gql`
  mutation submitCategorizedContactForm($contactFormInput: CategorizedContactFormInput!) {
    categorizedContactForm(contactFormInput: $contactFormInput) {
      status
    }
  }
`;
export const CreateSolarPanelInstallationLeadCompactDocument = gql`
  mutation createSolarPanelInstallationLeadCompact(
    $createSolarPanelInstallationLeadInput: CreateSolarPanelInstallationLeadInput!
  ) {
    createSolarPanelInstallationLeadCompact(input: $createSolarPanelInstallationLeadInput) {
      isSend
    }
  }
`;
export const EaasCreateMarketingLeadDocument = gql`
  mutation eaasCreateMarketingLead($input: CreateMarketingLeadInput!) {
    eaasCreateMarketingLead(input: $input) {
      isSent
    }
  }
`;
export const NcsParkLeadDocument = gql`
  mutation ncsParkLead($ncsParkLeadInput: NcsParkLeadInput!) {
    ncsParkLead(input: $ncsParkLeadInput) {
      isSent
    }
  }
`;
export const GetCitiesDocument = gql`
  query getCities($postcode: String) {
    citiesByPostcode(postcode: $postcode) {
      name
      cityId
    }
  }
`;
export const GetCitiesAndStreetsDocument = gql`
  query getCitiesAndStreets($postcode: String) {
    citiesByPostcode(postcode: $postcode) {
      name
      cityId
      streets {
        name
      }
    }
  }
`;
export const GetContactFormReasonsDocument = gql`
  query getContactFormReasons($token: String) {
    contactFormReasons(token: $token) {
      contactFormReasons {
        id
        key
        label
        applicableB2B
        applicableB2C
        applicableServiceView
        applicableWebsite
        applicableToWebsiteForLead
      }
      majaId
      williId
      status
    }
  }
`;
export const EnergyPriceCurveDocument = gql`
  query EnergyPriceCurve($input: LocationSpecificEnergyPriceCurveInput!) {
    locationSpecificEnergyPriceCurve(input: $input) {
      energyPriceCurvesResponse {
        averagePriceInCents
        maxPrice {
          time
          valueInCents
        }
        minPrice {
          time
          valueInCents
        }
        energyPricesInCents {
          time
          valueInCents
        }
        maxAvgPriceRange {
          startTime
          endTime
          averagePrice
        }
        minAvgPriceRange {
          startTime
          endTime
          averagePrice
        }
      }
    }
  }
`;

//# sourceMappingURL=generated.lichtblick.js.map